/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

//should inform Backend Team if any modifications done in this file

import * as yup from 'yup';
import {
  Bank,
  ControllingPersons,
  Groups,
  NomineeType,
  nonIndividualQuestionsFatca,
  ubo,
  Applicant,
  Broker,
  coparcenersType,
} from '../redux-store/types/api-types';
import {
  accountNumberRegex,
  ifscRegex,
  stringRegex,
  addressRegex,
  phoneRegExp,
  nonIndividualPanRegex,
  emailRegex,
  individualPanRegex,
  numberRegex,
  amountRegex,
  alphaNumeric,
  indianPin,
  arnCodeRegex,
  pinCodeRegexOtherThanIndia,
  cdslRegex,
  dpIdRegex,
  aadhaarRegex,
  ssnRegex,
  neftCodeRgx,
  percentageMonthsRegex,
  defaultRegexWithSingleLine,
  alphaNumericSentence,
  dpIdNumberRegex,
  dpIdRegexForNSDL,
  dpIdRegexForCDSL,
  clIdRegex,
  ckycNumberRegex,
  percentageRegex,
  percentageCommaSparatedRegex,
} from './regex';
import {
  isMinor,
  currencyConversion,
  maxAge,
  getCountryCodes,
  checkForCorrespondenceAddress,
  checkUBOTypeIsTrust,
  getdpIdField,
  getclIdField,
  isCDSL,
  checkValidationBasedOnDate,
  getCountryBasedOnStatus,
  isOnboardingTypeMinor,
  futureAge,
  isFatherMother,
  isFirstApplicant,
  isOtherSourceOfFund,
  isAadhaarSelected,
  isChequeOrRTGS,
  isNEFT,
  isUboTypeIndividual,
  isUboTypeNonIndividual,
  checkApplicantNri,
  checkApplicantResident,
  isPassportSelected,
  getPanAadhaarMasterBasedOnstatus,
  getOverseasCountryIfExist,
  isBankAccountProof,
  isDocTypeCheque,
  isCkycMandatory,
  getApplicantStatus,
  getGrossAnnualMasters,
  isOtherOccupation,
  isFieldApplicable,
  isFieldVariable,
} from './utilityFunctions';
import { InternalOptions } from 'yup/lib/types';
import { Values } from '../components/investors/contactDetails';
import { Distributor, SubDistributor } from '../redux-store/actions';
import { Values as ContributorValues } from '../components/investors/contributorDetails';
import { Values as DocumentValues } from '../components/investors/documentDetails';
import { Values as KycValues } from '../components/investors/additionalKYCDetails';
import { Values as NonIndividualDocValues } from '../components/NonIndividualInvestor/DocumentDetails';
import { getSubQuestionsIndex } from '../components/NonIndividualInvestor/fatca';
import {
  AADHAAR_OR_SSN_MASTER,
  addressTypesMasters,
  adminSupportMaster,
  applicantStatusMasters,
  APPLICATION_TYPE,
  BankAccountTypeMaster,
  CKYC_SELECTION_OPTIONS_OBJECT,
  ContactRelations,
  CpUboCodesMaster,
  DematDetialsValidationModified,
  dematFieldValidationDate,
  DISTRIBUTION_FEE_TYPE_MASTER,
  DistributorFeeValidationStartDate,
  distributorRmNameStartDate,
  DLCLMasters,
  dpIdFieldValidationDate,
  FEE_TYPE_MASTER,
  genderMasters,
  INVESTOR_CONSENT_FLOW,
  investorTypeMasters,
  isNaturalParent,
  MODE_OF_PAYMENT_MASTER,
  ModeOfHoldingMasterForJointHolders,
  NomineeIdFieldValidationDate,
  NomineeRelations,
  NRIBankAccountTypeMaster,
  occupationDetailsMasters,
  otherOccupationStartDate,
  PAN_AADHAAR_MASTER,
  PEPsMasters,
  Relations,
  SIP_MASTER,
  SOURCE_OF_FUNDS_MASTER,
  UboCategoryMaster,
  UboTypeMaster,
  YES_NO_MASTER,
} from './constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { Values as NonIndividualContactValues } from '../components/NonIndividualInvestor/ContactDetails';
import { Values as individualFatcaValues } from '../components/investors/fatca';
import { checkDrawdown, checkLumpsum, checkSip } from '../components/FundsSetup/addFund';
import { SipInvestmentModeProp } from '../redux-store/types/funds';

export const contributorDetailsSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      name: yup.string().nullable().required('Name is required'),
      gender: yup
        .string()
        .nullable()
        .oneOf(genderMasters, 'Invalid value for Gender')
        .required('Please select gender'),
      motherName: yup
        .string()
        .nullable()
        .required('Mother Name is required')
        .matches(stringRegex, 'Special characters and numbers not allowed'),
      fatherOrSpouseName: yup.string().nullable().required('Father/Spouse Name is required'),
      dateOfBirth: yup
        .string()
        .nullable()
        .test(
          'dateOfBirth',
          'Age should be greater than 18',
          (dateOfBirth) => !isMinor(dateOfBirth || '')
        )
        .required('Date of Birth is required'),
      status: yup
        .string()
        .nullable()
        .required('Status is required')
        .test('status', (value, context) => {
          const { path, parent, createError } = context;
          if (value && !getApplicantStatus(parent?.applicant_type).includes(value)) {
            return createError({
              message: 'Invalid value for Status',
              path,
            });
          }
          return true;
        }),
      // aadhaarOrSsn: yup
      //   .string()
      //   .nullable()
      //   .required('Aadhaar Number/SSN is required')
      //   .oneOf(Object.keys(AADHAAR_OR_SSN_MASTER), 'Invalid value for Aadhaar Number/SSN'),
      aadhaarNumber: yup
        .string()
        .nullable()
        .when('status', {
          is: (status: string) => status && checkApplicantResident(status),
          then: yup
            .string()
            .nullable()
            .required('Aadhaar Number of Investor is required')
            .matches(aadhaarRegex, 'Invalid Aadhaar Number of Investor'),
        }),
      // ssn: yup
      //   .string()
      //   .nullable()
      //   .when('aadhaarOrSsn', {
      //     is: (aadhaarOrSsn: string) => !isAadhaarSelected(aadhaarOrSsn),
      //     then: yup
      //       .string()
      //       .nullable()
      //       .required('SSN Number of NRI/NRI(PIO) is required')
      //       .matches(ssnRegex, 'Invalid SSN Number of NRI/NRI(PIO)'),
      //   }),
      passportOrOci: yup
        .string()
        .nullable()
        .when('status', {
          is: (status: string) => status && checkApplicantNri(status),
          then: yup.string().nullable().required('Passport or OCI is required'),
        }),
      passport: yup
        .string()
        .nullable()
        .when(['status', 'passportOrOci'], {
          is: (status: string, passportOrOci: string) =>
            status && checkApplicantNri(status) && isPassportSelected(passportOrOci),
          then: yup
            .string()
            .nullable()
            .required('Passport is required')
            .matches(alphaNumeric, 'Invalid Passport'),
        }),
      oci: yup
        .string()
        .nullable()
        .when(['status', 'passportOrOci'], {
          is: (status: string, passportOrOci: string) =>
            status &&
            checkApplicantNri(status) &&
            passportOrOci &&
            !isPassportSelected(passportOrOci),
          then: yup
            .string()
            .nullable()
            .required('OCI is required')
            .matches(alphaNumeric, 'Invalid OCI'),
        }),
      nationality: yup
        .string()
        .nullable()
        .test('nationality', (value, context) => {
          const fieldValue = value === null ? '' : value;
          const { options, createError, path, parent } = context;
          const { context: optionsContext } = options as InternalOptions<ContributorValues>;
          const { nationalityDropdown = [] } = optionsContext || {};
          if (!fieldValue) {
            return createError({
              message: 'Nationality is required',
              path,
            });
          }
          if (!nationalityDropdown.includes(fieldValue)) {
            return createError({
              message: 'Invalid value for Nationality',
              path,
            });
          }
          // if (
          //   applicantStatusMasters[parent.status] === applicantStatusMasters.NRI &&
          //   value?.toUpperCase() !== 'INDIAN'
          // ) {
          //   return createError({
          //     message: 'Invalid value for Nationality',
          //     path,
          //   });
          // }
          return true;
        }),
      jointApplicantRelation: yup
        .string()
        .nullable()
        .test('jointApplicationRelation', (value, context) => {
          const fieldValue = value === null ? '' : value;
          const { options, createError, path } = context;
          const { index } = options as InternalOptions<ContributorValues> & {
            index: number;
          };

          if (index !== 0) {
            if (!fieldValue) {
              return createError({
                message: 'Relationship with first applicant is required',
                path,
              });
            }
            if (fieldValue && !Relations.includes(fieldValue)) {
              return createError({
                message: 'Invalid value for Relationship with first applicant',
                path,
              });
            }
          }
          return true;
        }),
      relationShipWithFirstApplicant: yup
        .string()
        .nullable()
        .when('jointApplicantRelation', {
          is: (jointApplicantRelation: string | null) => jointApplicantRelation === 'Others',
          then: yup.string().nullable().required('Please Specify Relationship'),
        }),
      minorPan: yup
        .string()
        .nullable()
        .uppercase()
        .length(10, 'PAN must be exactly 10 characters')
        .test('pan', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (!fieldValue) {
            return true;
          }
          if (!individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'Only individual PANs are allowed',
              path,
            });
          }
          if (fieldValue === parent.panNo) {
            return createError({
              message: 'Minor PAN should not be same as Guardian PAN',
              path,
            });
          }
          return true;
        }),
      minorDOB: yup
        .string()
        .nullable()
        .test('minorDOB', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (isOnboardingTypeMinor(parent.onboardingType)) {
            if (!fieldValue) {
              return createError({
                message: 'Date of Birth is required',
                path,
              });
            }
            if (futureAge(fieldValue || '')) {
              return createError({
                message: 'Future date cannot be entered',
                path,
              });
            }
            if (!isMinor(fieldValue)) {
              return createError({
                message: 'Age should be less than 18',
                path,
              });
            }
          }
          return true;
        }),
      minorName: yup
        .string()
        .nullable()
        .test('minorName', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
            return createError({
              message: 'Minor Name is required',
              path,
            });
          }
          return true;
        }),
      //   .string()
      //   .nullable()
      //   .test('minorFirstName', (value, context) => {
      //     const fieldValue = value === undefined ? '' : value;
      //     const { path, createError, parent } = context;
      //     if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
      //       return createError({
      //         message: 'Minor First Name is required',
      //         path,
      //       });
      //     }
      //     return true;
      //   }),
      // minorLastName: yup
      //   .string()
      //   .nullable()
      //   .test('minorLastName', (value, context) => {
      //     const fieldValue = value === undefined ? '' : value;
      //     const { path, createError, parent } = context;
      //     if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
      //       return createError({
      //         message: 'Minor Last Name is required',
      //         path,
      //       });
      //     }
      //     return true;
      //   }),
      guardianRelationship: yup
        .string()
        .nullable()
        .test('guardianRelationship', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
            return createError({
              message: 'Relationship with guardian is required',
              path,
            });
          }
          return true;
        }),
      naturalParent: yup
        .string()
        .nullable()
        .test('naturalParent', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (
            isOnboardingTypeMinor(parent.onboardingType) &&
            isFatherMother(parent.guardianRelationship || '')
          ) {
            if (!fieldValue) {
              return createError({
                message: 'Natural Parents field is required',
                path,
              });
            } else if (fieldValue && !Object.keys(isNaturalParent).includes(fieldValue)) {
              return createError({
                message: 'Invalid value for Natural Parents',
                path,
              });
            }
          }
          return true;
        }),
      guardianRelationshipTypeOther: yup
        .string()
        .nullable()
        .test('guardianRelationshipTypeOther', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (
            isOnboardingTypeMinor(parent.onboardingType) &&
            parent.guardianRelationship === 'OTHERS'
          ) {
            if (!fieldValue) {
              return createError({
                message: 'Please specify Relationship with guardian is required',
                path,
              });
            } else if (!stringRegex.test(fieldValue)) {
              return createError({
                message: 'Special characters and numbers not allowed',
                path,
              });
            }
          }
          return true;
        }),
      minorFatherName: yup
        .string()
        .nullable()
        .test('minorFatherName', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
            return createError({
              message: 'Minor Father Name is required',
              path,
            });
          }
          return true;
        }),
      minorGender: yup
        .string()
        .nullable()
        .test('minorGender', (value, context) => {
          const fieldValue = value === undefined ? '' : value;
          const { path, createError, parent } = context;
          if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
            return createError({
              message: 'Minor Gender is required',
              path,
            });
          }
          return true;
        }),

      minorEmail: yup.string().nullable().matches(emailRegex, 'Invalid Email ID'),
      minorMobile: yup
        .string()
        .nullable()
        .test('minorMobile', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === parent.minorCountryNameAndCode) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (
            value &&
            parent.minorCountryNameAndCode === 'India: +91' &&
            !phoneRegExp.test(value as any)
          ) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }
          if (value && !isValidPhoneNumber(value as any, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }
          return true;
        }),
    })
  ),
  modeOfHolding: yup
    .string()
    .nullable()
    .test('modeOfHolding', 'Invalid value', (value, context) => {
      const { parent, path, createError } = context;
      if (
        parent.applicants.length > 1 &&
        value &&
        !Object.keys(ModeOfHoldingMasterForJointHolders).includes(value)
      ) {
        return false;
      }
      return true;
    }),
});

const validateOverseasAddressFields = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>
) => {
  const fieldValue = !value ? '' : value;
  const { options } = context;
  const { context: optionsContext, index } = options as InternalOptions<Values> & {
    index: number;
  };
  const { applicants = [] } = optionsContext || {};
  const currentApplicant = applicants[index] || {};
  const { nationality, status } = currentApplicant.address;
  return checkForCorrespondenceAddress(nationality, status) ? true : fieldValue !== '';
};

const validatePermanentAddressFields = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>,
  applicationType: string
) => {
  const fieldValue = !value ? '' : value;
  const { options } = context;
  const { context: optionsContext, index } = options as InternalOptions<Values> & {
    index: number;
  };
  const { applicants = [] } = optionsContext || {};
  const currentApplicant = applicants[index] || {};
  const { nationality, status = '' } = currentApplicant.address;
  const { permanentAddressSameAsCorresponding = false } =
    checkForCorrespondenceAddress(nationality, status) ||
    APPLICATION_TYPE.NON_INDIVIDUAL === applicationType
      ? currentApplicant.address.correspondence || {}
      : currentApplicant.address.overseas || {};
  return permanentAddressSameAsCorresponding ? true : fieldValue !== '';
};

const validatePincodeField = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>,
  addressType: string
) => {
  const fieldValue = value === undefined ? '' : value;
  const { options, path, createError, parent } = context;
  const { context: optionsContext, index } = options as InternalOptions<Values> & {
    index: number;
  };
  const { applicants = [] } = optionsContext || {};
  const currentApplicant = applicants[index] || {};
  const { nationality, status = '' } = currentApplicant.address;
  if (addressType === 'correspondence' && !checkForCorrespondenceAddress(nationality, status)) {
    return true;
  }
  if (addressType === 'overseas' && checkForCorrespondenceAddress(nationality, status)) {
    return true;
  }
  if (!fieldValue) {
    return createError({
      message: 'Pincode is required',
      path,
    });
  }
  if (parent.country?.toLowerCase() === 'india' && !indianPin.test(fieldValue)) {
    return createError({
      message: 'Pincode should be 6 digit code',
      path,
    });
  }
  if (parent.country?.toLowerCase() !== 'india' && !pinCodeRegexOtherThanIndia.test(fieldValue)) {
    return createError({
      message: 'Invalid Pincode',
      path,
    });
  }

  return true;
};

const validateCorrespondenceAddressFields = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>
) => {
  const fieldValue = !value ? '' : value;
  const { options } = context;
  const { context: optionsContext, index } = options as InternalOptions<Values> & {
    index: number;
  };
  const { applicants = [] } = optionsContext || {};
  const currentApplicant = applicants[index] || {};
  const { nationality, status = '' } = currentApplicant.address;
  return checkForCorrespondenceAddress(nationality, status) ? fieldValue !== '' : true;
};

export const contactDetailsSchema = (beApplicants: Partial<Applicant>[]) =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        phoneNumberoffice: yup.string().nullable(),
        phoneNumberResidence: yup.string().nullable(),
        email: yup
          .string()
          .nullable()
          .matches(emailRegex, 'Invalid Email ID')
          .required('Email is required'),
        emailDeclaration: yup
          .string()
          .nullable()
          .required('Email Id Belongs To is required')
          .test(
            'emailDeclaration',
            (
              value: string | undefined | null,
              context: yup.TestContext<Record<string, Values>>
            ) => {
              const fieldValue = !value ? '' : value;
              const { path, createError } = context;
              if (fieldValue && !Object.keys(ContactRelations).includes(fieldValue)) {
                return createError({
                  message: 'Invalid value for Email Id Belongs To',
                  path,
                });
              }
              return true;
            }
          ),
        mobile: yup
          .string()
          .nullable()
          .test('mobile', (value, context) => {
            const { createError, path, parent } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === parent.countryNameAndCode) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            if (!value) {
              return createError({
                message: 'Mobile is required',
                path,
              });
            }
            if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }
            if (!isValidPhoneNumber(value, codesList as CountryCode)) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }

            return true;
          }),
        mobileDeclaration: yup
          .string()
          .nullable()
          .required('Mobile Number Belongs To is required')
          .test(
            'mobileDeclaration',
            (
              value: string | undefined | null,
              context: yup.TestContext<Record<string, Values>>
            ) => {
              const fieldValue = !value ? '' : value;
              const { path, createError, parent, options } = context;
              const { context: optionsContext } = options as InternalOptions<Values> & {
                index: number;
              };
              const { applicants = [] } = optionsContext || {};
              if (fieldValue && !Object.keys(ContactRelations).includes(fieldValue)) {
                return createError({
                  message: 'Invalid value for Mobile Number Belongs To',
                  path,
                });
              }
              if (
                parent.mobile &&
                fieldValue &&
                ContactRelations[fieldValue] === ContactRelations.self &&
                applicants.filter(
                  (applicant) =>
                    applicant.mobile === parent.mobile &&
                    ContactRelations[applicant.mobileDeclaration] === ContactRelations.self
                ).length !== 1
              ) {
                return createError({
                  message: `RelationShip can't be choosen as ${ContactRelations[fieldValue]} for joint holders who has same mobile number`,
                  path,
                });
              }
              return true;
            }
          ),
        countryNameAndCode: yup
          .string()
          .nullable()
          .test('countryNameAndCode', (value, context) => {
            const { createError, path, parent } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === value) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            if (!value) {
              return createError({
                message: 'Country Code is required',
                path,
              });
            }
            if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }

            return true;
          }),
        address: yup.object().shape({
          correspondence: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) =>
                validateCorrespondenceAddressFields(value, context)
              ),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address2', 'Address line 2 is required', (value, context) =>
                // {
                //   const { options } = context;
                //   const { context: optionsContext, index } = options as InternalOptions<Values> & {
                //     index: number;
                //   };
                //   const { applicants = [] } = optionsContext || {};
                //   const currentApplicant = applicants[index] || {};
                //   const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
                //   if (!fetchedFromKRA) {
                //     return validateCorrespondenceAddressFields(value, context);
                //   }
                //   return true;
                // }
                validateCorrespondenceAddressFields(value, context)
              ),
            pincode: yup
              .string()
              .nullable()
              .test('pincode', (value, context) =>
                validatePincodeField(value, context, 'correspondence')
              ),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) =>
                validateCorrespondenceAddressFields(value, context)
              ),
            state: yup
              .string()
              .nullable()
              .test('state', 'State is required', (value, context) =>
                validateCorrespondenceAddressFields(value, context)
              ),
            // country: yup
            // .string()
            // .nullable()
            // .test('country', 'Country is required', (value, context) =>
            // validateCorrespondenceAddressFields(value, context)
            // ),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { countryDropdown = [], applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status = '' } = currentApplicant.address;

                if (!value && checkForCorrespondenceAddress(nationality, status)) {
                  return createError({
                    message: 'Country is required',
                    path,
                  });
                }
                if (
                  value &&
                  checkForCorrespondenceAddress(nationality, status) &&
                  !countryDropdown.includes(value)
                ) {
                  return createError({
                    message: 'Invalid value for Country',
                    path,
                  });
                }
                return true;
              }),
          }),
          overseas: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) =>
                validateOverseasAddressFields(value, context)
              ),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address2', 'Address line 2 is required', (value, context) =>
                validateOverseasAddressFields(value, context)
              ),
            pincode: yup
              .string()
              .nullable()
              .test('pincode', (value, context) =>
                validatePincodeField(value, context, 'overseas')
              ),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) =>
                validateOverseasAddressFields(value, context)
              ),
            // state: yup
            //   .string()
            //   .nullable()
            //   .test('state', 'State is required', (value, context) =>
            //     validateOverseasAddressFields(value, context)
            //   ),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [], overseasCountryDropdown = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status = '' } = currentApplicant.address;
                if (!value && checkForCorrespondenceAddress(nationality, status)) {
                  return true;
                }
                if (!value) {
                  return createError({
                    message: 'Country is required',
                    path,
                  });
                }
                if (value.toUpperCase() === 'INDIA') {
                  return createError({
                    message: "Country can't be choosen as INDIA",
                    path,
                  });
                }
                if (!overseasCountryDropdown.includes(value)) {
                  return createError({
                    message: 'Invalid value for Country',
                    path,
                  });
                }
                return true;
              }),
            preferredCommAddress: yup
              .boolean()
              .nullable()
              .test('preferredCommAddress', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants: feApplicants = [] } = optionsContext || {};
                const feApplicant = feApplicants[index] || {};
                const beApplicant = beApplicants[index] || {};
                const { status = '' } = beApplicant as Partial<Applicant>;
                const isPreferredCommAddressSelected = feApplicants.reduce((acc, applicant) => {
                  if (applicant.address.overseas?.preferredCommAddress) acc += 1;
                  if (applicant.address.permanent?.preferredCommAddress) acc += 1;
                  return acc;
                }, 0);
                if (checkApplicantNri(status) && isPreferredCommAddressSelected < 1) {
                  return createError({
                    message: 'Please select preferred communication address',
                    path,
                  });
                }
                return true;
              }),
            // country: yup
            //   .string()
            //   .nullable()
            //   .test('country', 'Country is required', (value, context) =>
            //     validateOverseasAddressFields(value, context)
            //   ),
          }),
          permanent: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) =>
                validatePermanentAddressFields(value, context, APPLICATION_TYPE.INDIVIDUAL)
              ),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              // .test('address2', 'Address2 is required', (value, context) =>
              //   validatePermanentAddressFields(value, context, APPLICATION_TYPE.INDIVIDUAL)
              // ),
              .test('address2', 'Address line 2 is required', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { fetchedFromKRA = null } = currentApplicant.address.permanent || {};
                if (!fetchedFromKRA) {
                  return validatePermanentAddressFields(
                    value,
                    context,
                    APPLICATION_TYPE.INDIVIDUAL
                  );
                }
                return true;
              }),
            pincode: yup
              .string()
              .trim()
              .nullable()
              .test('pincode', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status = '' } = currentApplicant.address;
                const { permanentAddressSameAsCorresponding = false } =
                  checkForCorrespondenceAddress(nationality, status)
                    ? currentApplicant.address.correspondence || {}
                    : currentApplicant.address.overseas || {};
                if (!permanentAddressSameAsCorresponding) {
                  return validatePincodeField(value, context, 'permanent');
                }
                return true;
              }),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) =>
                validatePermanentAddressFields(value, context, APPLICATION_TYPE.INDIVIDUAL)
              ),
            state: yup
              .string()
              .nullable()
              .test('state', 'State is required', (value, context) =>
                validatePermanentAddressFields(value, context, APPLICATION_TYPE.INDIVIDUAL)
              ),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { countryDropdown = [] } = optionsContext || {};
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status } = currentApplicant.address;
                const { permanentAddressSameAsCorresponding = false } =
                  checkForCorrespondenceAddress(nationality, status)
                    ? currentApplicant.address.correspondence || {}
                    : currentApplicant.address.overseas || {};
                if (!permanentAddressSameAsCorresponding) {
                  if (!value) {
                    return createError({
                      message: 'Country is required',
                      path,
                    });
                  }
                  // if (
                  //   applicantStatusMasters[status || ''] === applicantStatusMasters.NRI &&
                  //   value.toUpperCase() === 'INDIA'
                  // ) {
                  //   return createError({
                  //     message:
                  //       "If the Status is Individual (NRI) then Country can't be choosen as INDIA",
                  //     path,
                  //   });
                  // }
                  if (!countryDropdown.includes(value)) {
                    return createError({
                      message: 'Invalid value for Country',
                      path,
                    });
                  }
                }
                return true;
              }),
            preferredCommAddress: yup
              .boolean()
              .nullable()
              .test('preferredCommAddress', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants: feApplicants = [] } = optionsContext || {};
                const feApplicant = feApplicants[index] || {};
                const beApplicant = beApplicants[index] || {};
                const { status = '' } = beApplicant as Partial<Applicant>;
                const isPreferredCommAddressSelected = feApplicants.reduce((acc, applicant) => {
                  if (applicant.address.overseas?.preferredCommAddress) acc += 1;
                  if (applicant.address.permanent?.preferredCommAddress) acc += 1;
                  return acc;
                }, 0);
                if (checkApplicantNri(status) && isPreferredCommAddressSelected < 1) {
                  return createError({
                    message: 'Please select preferred communication address',
                    path,
                  });
                }
                return true;
              }),
            // country: yup
            //   .string()
            //   .nullable()
            //   .test('country', 'Country is required', (value, context) =>
            //     validatePermanentAddressFields(value, context)
            //   ),
          }),
        }),
      })
    ),
  });

export const KYCDetailsSchema = (
  brokers: Broker[],
  createdAt: string,
  applicants: Partial<Applicant>[]
) =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        occupationDetails: yup
          .string()
          .oneOf(occupationDetailsMasters, 'Invalid value for occupation details')
          .required('Occupation details is required'),
        otherOccupationDetails: yup
          .string()
          .nullable()
          .when('occupationDetails', {
            is: (occupationDetails: string) =>
              isOtherOccupation(occupationDetails) &&
              checkValidationBasedOnDate(createdAt || '', otherOccupationStartDate),
            then: yup.string().nullable().required('Please specify other occupation'),
          }),
        grossAnnualIncome: yup
          .string()
          .nullable()
          .oneOf(getGrossAnnualMasters(createdAt || ''), 'Invalid value for Gross Annual Income')
          .required('Gross Annual Income is required'),
        politicallyExposedPersonStatus: yup
          .string()
          .oneOf(PEPsMasters, 'Invalid value for PEP Status')
          .required('PEP status is required'),
        ckyc_selection_options: yup
          .string()
          .nullable()
          .required('Ckyc required')
          .oneOf(Object.keys(CKYC_SELECTION_OPTIONS_OBJECT), 'Invalid Value'),
        ckycNo: yup.string().test('ckycNo', (value, context) => {
          const {
            options: { context: optionsContext },
            createError,
            path,
            parent,
          } = context;
          //eslint-disable-next-line
          const { applicants } = optionsContext || {};
          if (!value && isCkycMandatory(parent?.ckyc_selection_options || '')) {
            return createError({
              message: 'CKYC No is required',
              path,
            });
          }
          if (value) {
            if (!ckycNumberRegex.test(value)) {
              return createError({
                message: 'Invalid CKYC No',
                path,
              });
            }
            // if (
            //   applicants.filter(
            //     (applicant: Applicant) => applicant.ckycNo?.toString() === value.toString()
            //   ).length !== 1
            // ) {
            //   return createError({
            //     message:
            //       'There is already same CKYC Number for an applicant associated with this application',
            //     path,
            //   });
            // }
          }
          return true;
        }),
        dlclId: yup
          .string()
          .nullable()
          .required('Demat Account Details (for allotment of units) is required')
          .oneOf(
            Object.keys(DLCLMasters),
            'Invalid value for Demat Account Details (for allotment of units)'
          ),
        dpId: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getdpIdField(dlclId || ''),
            then: yup
              .string()
              .nullable()
              .test('dpId', (value, context) => {
                const { path, createError, parent } = context;
                if (!checkValidationBasedOnDate(createdAt, DematDetialsValidationModified)) {
                  if (!value) {
                    return createError({
                      message: `${isCDSL(parent.dlclId) ? 'DPCL ID' : 'DP ID'} is required`,
                      path,
                    });
                  }

                  if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
                    if (value && !isCDSL(parent.dlclId) && !dpIdRegex.test(value)) {
                      return createError({
                        message: `DP ID should consist of 8 digits and must start with 'IN'`,
                        path,
                      });
                    }

                    if (value && isCDSL(parent.dlclId)) {
                      if (
                        !dpIdNumberRegex.test(value) &&
                        checkValidationBasedOnDate(createdAt, dpIdFieldValidationDate)
                      ) {
                        return createError({
                          message: 'DPCL ID should consist of 16 numeric digits',
                          path,
                        });
                      }
                      if (
                        !checkValidationBasedOnDate(createdAt, dpIdFieldValidationDate) &&
                        !(cdslRegex.test(value) || dpIdNumberRegex.test(value))
                      ) {
                        return createError({
                          message: 'DPCL ID should consist of 8 or 16 numeric digits',
                          path,
                        });
                      }
                      return true;
                    }
                    return true;
                  }
                }
                if (checkValidationBasedOnDate(createdAt, DematDetialsValidationModified)) {
                  if (!value) {
                    return createError({
                      message: `DP ID is required`,
                      path,
                    });
                  }
                  if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
                    if (value && isCDSL(parent.dlclId) && !dpIdRegexForCDSL.test(value)) {
                      return createError({
                        message: `DP ID should consist of 8 numeric digits`,
                        path,
                      });
                    }

                    if (value && !isCDSL(parent.dlclId) && !dpIdRegexForNSDL.test(value)) {
                      return createError({
                        message: `DP ID should consist of 8 digits and must start with 'IN'`,
                        path,
                      });
                    }
                    return true;
                  }
                  return true;
                }
                return true;
              }),
          }),
        clId: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getclIdField(dlclId || '', createdAt),
            then: yup
              .string()
              .nullable()
              .test('clId', (value, context) => {
                const { path, createError, options } = context;
                if (!value) {
                  return createError({
                    message: 'CL ID is required',
                    path,
                  });
                }
                if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
                  // if (value && !cdslRegex.test(value)) {
                  if (value && !clIdRegex.test(value)) {
                    return createError({
                      message: 'CL ID should consist of 8 numeric digits',
                      path,
                    });
                  }
                }
                return true;
              }),
          }),
        nameOfBroker: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getdpIdField(dlclId || ''),
            then: yup
              .string()
              .nullable()
              .test('nameOfBroker', (value, context) => {
                const { path, createError } = context;
                const brokerList = brokers.map((broker) => broker.key);
                if (!value) {
                  return true;
                }
                if (value && !brokerList.includes(value)) {
                  return createError({
                    message: 'Invalid value for Name of Broker/Depository Participant (DP)',
                    path,
                  });
                }
                return true;
              }),
          }),
        dematName: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getdpIdField(dlclId || ''),
            then: yup.string().nullable().required('Name as per the Demat Account is required'),
          }),
        amcCallVerified: yup
          .string()
          .nullable()
          .test('amcCallVerified', (value, context) => {
            const { options, createError, path } = context;
            const { index } = options as InternalOptions<KycValues> & {
              index: number;
            };
            if (isFirstApplicant(applicants[index])) {
              if (!value) {
                return createError({
                  message: 'AMC Call Verified is required',
                  path,
                });
              } else if (!Object.keys(YES_NO_MASTER).includes(value)) {
                return createError({
                  message: 'Invalid value for AMC Call Verified',
                  path,
                });
              }
            }
            return true;
          }),
        sourceOfFunds: yup
          .string()
          .nullable()
          // .required('Source of funds is required')
          .oneOf(Object.keys(SOURCE_OF_FUNDS_MASTER), 'Invalid value for source of funds'),
        otherSourceOfFunds: yup
          .string()
          .nullable()
          .when('sourceOfFunds', {
            is: (sourceOfFunds: string) => sourceOfFunds && isOtherSourceOfFund(sourceOfFunds),
            then: yup.string().nullable().required('Other source of funds is required'),
          }),
        panAadhaarLinked: yup
          .string()
          .nullable()
          .required('PAN/Aadhaar linked is required')
          .test('panAadhaarLinked', (value, context) => {
            const { createError, path } = context;
            if (value && !Object.keys(PAN_AADHAAR_MASTER).includes(value)) {
              return createError({
                message: 'Invalid value for PAN/Aadhaar linked',
                path,
              });
            }
            return true;
          }),
      })
    ),
  });

const createSchemaForNonIndianResident = (validationMessage: string) => {
  return {
    is: (value: string) => value.toString() === 'true',
    then: yup.string().required(validationMessage),
  };
};

const allowedForNonNRI = addressTypesMasters.filter((address) => address !== 'Overseas');

export const FATCAValidationSchema = (applicants: Partial<Applicant>[]) =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        typeOfAddressProvidedAtKRA: yup.string().when('status', {
          is: 'NRI',
          then: yup
            .string()
            .oneOf(addressTypesMasters, 'Invalid value for Type of Address Provided At KRA')
            .required('Please select type of address provided'),
          otherwise: yup
            .string()
            .oneOf(allowedForNonNRI, 'Invalid value for Type of Address Provided At KRA')
            .required('Please select type of address provided'),
        }),
        placeOfBirth: yup
          .string()
          .required('Please enter place of birth')
          .matches(stringRegex, 'Special characters and numbers not allowed'),
        // countryOfBirth: yup
        //   .string()
        //   .required('Please enter country of birth')
        //   .matches(stringRegex, 'Please enter country of birth'),
        countryOfBirth: yup
          .string()
          .nullable()
          .test('countryOfBirth', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path, parent } = context;
            const { context: optionsContext } = options as InternalOptions<individualFatcaValues>;
            const { countryDropdown = [] } = optionsContext || {};
            if (!fieldValue) {
              return createError({
                message: 'country of birth is required',
                path,
              });
            }
            if (!countryDropdown.map((list) => list.name).includes(fieldValue)) {
              return createError({
                message: 'Invalid value for country of birth',
                path,
              });
            }
            return true;
          }),
        // countryOfNationality: yup
        //   .string()
        //   .required('Please enter country of nationality')
        //   .matches(stringRegex, 'Please enter country of nationality'),
        countryOfNationality: yup
          .string()
          .nullable()
          .test('countryOfNationality', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path, parent } = context;
            const { context: optionsContext } = options as InternalOptions<individualFatcaValues>;
            const { countryDropdown = [] } = optionsContext || {};
            if (!fieldValue) {
              return createError({
                message: 'country of nationality is required',
                path,
              });
            }
            if (
              !getCountryBasedOnStatus(countryDropdown, parent.statusSubType)
                .map((list) => list.name)
                .includes(fieldValue)
            ) {
              return createError({
                message: 'Invalid value for country of nationality',
                path,
              });
            }
            return true;
          }),
        taxCountryName: yup
          .string()
          .nullable()
          .when('taxResidentOfAnyCountryOtherThanIndia', {
            is: (value: string) => value.toString() === 'true',
            then: yup
              .string()
              .nullable()
              .required('Please enter tax country name')
              .test('taxCountryName', (value, context) => {
                const fieldValue = !value ? '' : value;
                const { options, createError, path } = context;
                const { context: optionsContext, index } =
                  options as InternalOptions<individualFatcaValues> & {
                    index: number;
                  };
                const { overseasCountryDropdown = [] } = optionsContext || {};
                const overseasCountry = getOverseasCountryIfExist(applicants[index]);
                if (
                  fieldValue &&
                  !overseasCountryDropdown.map((country) => country.name).includes(fieldValue)
                ) {
                  return createError({
                    message: 'Invalid value for tax country name',
                    path,
                  });
                }
                if (fieldValue && overseasCountry && overseasCountry !== fieldValue) {
                  return createError({
                    message: 'Tax country name should be same as overseas address country',
                    path,
                  });
                }
                return true;
              }),
          }),
        taxID: yup
          .string()
          .max(20, 'Invalid Tax ID')
          .when(
            'taxResidentOfAnyCountryOtherThanIndia',
            createSchemaForNonIndianResident('Please enter Tax ID')
          ),
        idType: yup
          .string()
          .when(
            'taxResidentOfAnyCountryOtherThanIndia',
            createSchemaForNonIndianResident('Please enter ID Type')
          ),
        // nameOfEntity: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter name of entity')
        //   ),
        // dateOfIncorporation: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter date of incorporation')
        //   ),
        // cityOfIncorporation: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter city of incorporation')
        //   ),
        // countryOfIncorporation: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter country of incorporation')
        //   ),
        // entityExcemptionCode: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter entity exemption code')
        //   ),
      })
    ),
  });

export const adminSupportValidation = yup.object().shape({
  supportType: yup.string().required('Support Type is required'),
  application_number: yup
    .string()
    .nullable()
    .when('supportType', {
      is: (supportType: string) =>
        [
          adminSupportMaster.change_expired_status,
          adminSupportMaster.change_status_to_draft,
        ].includes(adminSupportMaster[supportType]),
      then: yup.string().required('Application Number is required'),
    }),
  status: yup
    .string()
    .nullable()
    .when('supportType', {
      is: (supportType: string) =>
        adminSupportMaster[supportType] === adminSupportMaster.change_expired_status,
      then: yup.string().required('Status is required'),
    }),
  phone: yup
    .string()
    .nullable()
    .when('supportType', {
      is: (supportType: string) =>
        ![
          adminSupportMaster.change_expired_status,
          adminSupportMaster.change_status_to_draft,
          adminSupportMaster.process_signed_applications,
        ].includes(adminSupportMaster[supportType]),
      then: yup.string().test('phone', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        return true;
      }),
    }),
  // .required('Mobile Number is required')
  // .min(8, 'Invalid mobile number')
  // .max(16, 'Invalid mobile number')
  // .matches(phoneRegExp, 'Invalid mobile number'),
  // countryCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }
  //     return true;
  //   }),
});

export const nomineeDetailsSchema = (createdAt: string, applicants?: Partial<Applicant>[]) =>
  yup.object().shape({
    nominees: yup.array().of(
      yup.object().shape({
        nomineeName: yup
          .string()
          .nullable()
          .when(['isActive'], {
            is: (isActive: boolean) => isActive,
            then: yup
              .string()
              .nullable()
              .matches(stringRegex, 'Special characters and numbers not allowed')
              .required('Nominee Name is required'),
          }),
        nomineeRelationship: yup.string().when(['Relationship', 'isActive'], {
          is: (Relationship: string | null, isActive: boolean) =>
            isActive && Relationship === 'OTHERS',
          then: yup
            .string()
            .matches(stringRegex, 'Special characters and numbers not allowed')
            .required('Please Specify Relationship'),
        }),
        Relationship: yup
          .string()
          .nullable()
          .when(['isActive'], {
            is: (isActive: boolean) => {
              return isActive;
            },
            then: yup
              .string()
              .nullable()
              .oneOf(NomineeRelations, 'Invalid value for Nominee Relationship')
              .required('Please select relationship'),
          }),

        dateOfBirth: yup
          .string()
          .nullable()
          .when(['isActive'], {
            is: (isActive: boolean) => {
              return isActive;
            },
            then: yup.string().nullable().required('Date of Birth is required'),
          }),
        nomineePercentage: yup.number().when(['isActive'], {
          is: (isActive: boolean) => isActive,
          then: yup
            .number()
            .required('Nominee % is required')
            .typeError('Nominee % should be a number')
            .test(
              'nomineePercentage',
              'Total Nominee % should be equal to 100%',
              (value, context) => {
                const {
                  options: { context: optionsContext },
                  createError,
                  path,
                } = context;
                if (value === 0) {
                  return createError({
                    message: 'Nominee % should be greater then 0',
                    path,
                  });
                }
                const { nominees } = optionsContext || {};
                const total = nominees
                  .filter((_nominee: NomineeType) => _nominee.isActive)
                  .map((nominee: NomineeType) => Number(nominee.nomineePercentage))
                  .reduce((a: number, b: number) => a + b, 0);
                return nominees.length && total === 100;
              }
            ),
        }),
        nomineeAddress1: yup
          .string()
          .nullable()
          .when(['isActive', 'addressSameAsApplicant'], {
            is: (isActive: boolean, addressSameAsApplicant: boolean) =>
              isActive && !addressSameAsApplicant,
            then: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid nominee address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .required('Nominee Address line 1 is required'),
          }),
        nomineeAddress2: yup
          .string()
          .nullable()
          .when(['isActive', 'addressSameAsApplicant'], {
            is: (isActive: boolean, addressSameAsApplicant: boolean) =>
              isActive && !addressSameAsApplicant,
            then: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid nominee address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .required('Nominee Address line 2 is required'),
          }),
        // nomineeAddress3: yup
        //   .string()
        //   .nullable()
        //   .when(['isActive', 'addressSameAsApplicant'], {
        //     is: (isActive: boolean, addressSameAsApplicant: boolean) =>
        //       isActive && !addressSameAsApplicant,
        //     then: yup
        //       .string()
        //       .nullable()
        //       .matches(
        //         addressRegex,
        //         "Invalid nominee address line 3 format [special characters are not allowed except -/',&()#:.]"
        //       )
        //       .required('Nominee Address line 3 is required'),
        //   }),
        nomineeCity: yup
          .string()
          .nullable()
          .when(['isActive', 'addressSameAsApplicant'], {
            is: (isActive: boolean, addressSameAsApplicant: boolean) =>
              isActive && !addressSameAsApplicant,
            then: yup
              .string()
              .nullable()
              .matches(stringRegex, 'Special characters and numbers not allowed')
              .required('Nominee City is required'),
          }),
        nomineeState: yup
          .string()
          .nullable()
          .when(['isActive', 'addressSameAsApplicant'], {
            is: (isActive: boolean, addressSameAsApplicant: boolean) =>
              isActive && !addressSameAsApplicant,
            then: yup
              .string()
              .nullable()
              .matches(stringRegex, 'Special characters and numbers not allowed')
              .required('Nominee State is required'),
          }),
        nomineePincode: yup
          .string()
          .nullable()
          .when(['isActive', 'addressSameAsApplicant'], {
            is: (isActive: boolean, addressSameAsApplicant: boolean) =>
              isActive && !addressSameAsApplicant,
            then: yup
              .string()
              .nullable()
              .test('nomineePincode', (value, context) => {
                const fieldValue = value === undefined ? '' : value;
                const { path, createError, parent } = context;

                if (!fieldValue) {
                  return createError({
                    message: 'Nominee Pincode is required',
                    path,
                  });
                }
                if (
                  parent.nomineeCountry?.toLowerCase() === 'india' &&
                  !indianPin.test(fieldValue)
                ) {
                  return createError({
                    message: 'Nominee Pincode should be 6 digit code',
                    path,
                  });
                }
                if (
                  parent.nomineeCountry?.toLowerCase() !== 'india' &&
                  !alphaNumeric.test(fieldValue)
                ) {
                  return createError({
                    message: 'Invalid Nominee Pincode',
                    path,
                  });
                }
                return true;
              }),
          }),
        nomineeCountry: yup
          .string()
          .nullable()
          .when(['isActive', 'addressSameAsApplicant'], {
            is: (isActive: boolean, addressSameAsApplicant: boolean) =>
              isActive && !addressSameAsApplicant,
            then: yup
              .string()
              .nullable()
              .test('nomineeCountry', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { countryDropdown = [] } = optionsContext || {};
                if (!value) {
                  return createError({
                    message: 'Nominee Country is required',
                    path,
                  });
                }

                if (value && !countryDropdown.includes(value)) {
                  return createError({
                    message: 'Invalid value for Nominee Country',
                    path,
                  });
                }
                return true;
              }),
          }),
        guardianName: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup.string().nullable().required('Guardian Name is required'),
          }),
        guardianDOB: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup.string().nullable().required('Guardian Date of Birth is required'),
          })
          .test('guardianDOB', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent } = context;
            if (futureAge(fieldValue || '') && parent.isActive) {
              return createError({
                message: 'Invalid Date',
                path,
              });
            }
            if (isMinor(fieldValue || '') && parent.isActive) {
              return createError({
                message: 'Age should be greater than 18',
                path,
              });
            }
            if (maxAge(fieldValue || '') && parent.isActive) {
              return createError({
                message: 'Age should be less than 125',
                path,
              });
            }
            return true;
          }),
        guardianAddress1: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid guardian address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .required('Guardian Address line 1 is required'),
          }),
        guardianAddress2: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid guardian address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .required('Guardian Address line 2 is required'),
          }),
        // guardianAddress3: yup
        //   .string()
        //   .nullable()
        //   .when(['dateOfBirth', 'isActive'], {
        //     is: (dateOfBirth: string | null, isActive: boolean) =>
        //       isActive && isMinor(dateOfBirth || ''),
        //     then: yup
        //       .string()
        //       .nullable()
        //       .matches(
        //         addressRegex,
        //         "Invalid guardian address line 3 format [special characters are not allowed except -/',&()#:.]"
        //       )
        //       .required('Guardian Address line 3 is required'),
        //   }),
        guardianCity: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .matches(stringRegex, 'Special characters and numbers not allowed')
              .required('Guardian City is required'),
          }),
        guardianState: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .matches(stringRegex, 'Special characters and numbers not allowed')
              .required('Guardian State is required'),
          }),
        guardianPincode: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .test('guardianPincode', (value, context) => {
                const fieldValue = value === undefined ? '' : value;
                const { path, createError, parent } = context;
                if (!fieldValue) {
                  return createError({
                    message: 'Guardian Pincode is required',
                    path,
                  });
                }
                if (
                  parent.guardianCountry?.toLowerCase() === 'india' &&
                  !indianPin.test(fieldValue)
                ) {
                  return createError({
                    message: 'Guardian Pincode should be 6 digit code',
                    path,
                  });
                }
                if (
                  parent.guardianCountry?.toLowerCase() !== 'india' &&
                  !alphaNumeric.test(fieldValue)
                ) {
                  return createError({
                    message: 'Invalid Guardian Pincode',
                    path,
                  });
                }
                return true;
              }),
          }),
        guardianCountry: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'isActive'], {
            is: (dateOfBirth: string | null, isActive: boolean) =>
              isActive && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .test('guardianCountry', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { countryDropdown = [] } = optionsContext || {};
                if (!value) {
                  return createError({
                    message: 'Guardian Country is required',
                    path,
                  });
                }
                if (value && !countryDropdown.includes(value)) {
                  return createError({
                    message: 'Invalid value for Guardian Country',
                    path,
                  });
                }
                return true;
              }),
          }),
        nomineePan: yup
          .string()
          .nullable()
          .matches(defaultRegexWithSingleLine, 'Invalid value for Nominee ID')
          .test('nomineePan', (value, context) => {
            const {
              options: { context: optionsContext },
              createError,
              path,
              parent,
            } = context;
            if (
              !value &&
              checkValidationBasedOnDate(createdAt || '', NomineeIdFieldValidationDate)
            ) {
              return createError({
                message: 'Nominee ID is required',
                path,
              });
            }
            return true;
          }),

        // nomineePan: yup
        //   .string()
        //   .nullable()
        //   .matches(individualPanRegex, 'Only individual PANs are allowed')
        //   .test('nomineePan', (value, context) => {
        //     const {
        //       options: { context: optionsContext },
        //       createError,
        //       path,
        //       parent,
        //     } = context;
        //     const { nominees = [] } = optionsContext || {};
        //     const applicantsPan = applicants?.map((applicant) => applicant.panNo) || [];
        //     if (!value && !isMinor(parent.dateOfBirth || '')) {
        //       return createError({
        //         message: 'Nominee PAN is required',
        //         path,
        //       });
        //     }
        //     if (value && applicantsPan.length && applicantsPan?.includes(value)) {
        //       return createError({
        //         message: 'Applicant PAN not allowed to enter as nominee PAN',
        //         path,
        //       });
        //     }
        //     if (
        //       value &&
        //       nominees.filter((nominee: NomineeType) => nominee.nomineePan === value).length !== 1
        //     ) {
        //       return createError({
        //         message: 'There is already same pan for a nominee associated with this application',
        //         path,
        //       });
        //     }
        //     if (value && parent.nomineeGuardianPan && value === parent.nomineeGuardianPan) {
        //       return createError({
        //         message: 'Nominee Pan should not be same as guardian PAN',
        //         path,
        //       });
        //     }
        //     return true;
        //   }),
        // nomineeGuardianPan: yup
        //   .string()
        //   .nullable()
        //   .when('dateOfBirth', {
        //     is: (dateOfBirth: string | null) => isMinor(dateOfBirth || ''),
        //     then: yup
        //       .string()
        //       .nullable()
        //       .matches(individualPanRegex, 'Only individual PANs are allowed')
        //       .test('nomineeGuardianPan', (value, context) => {
        //         const {
        //           options: { context: optionsContext },
        //           createError,
        //           path,
        //           parent,
        //         } = context;
        //         // if (!value && isMinor(parent.dateOfBirth || '')) {
        //         //   return createError({
        //         //     message: 'Guardian Pan is required',
        //         //     path,
        //         //   });
        //         // }
        //         if (value && parent.nomineePan && value === parent.nomineePan) {
        //           return createError({
        //             message: 'Guardian Pan should not be same as nominee PAN',
        //             path,
        //           });
        //         }
        //         return true;
        //       }),
        //   }),
      })
    ),
  });

export const bankDetailsSchema = (applicants: Partial<Applicant>[] | undefined) =>
  yup.object().shape({
    banks: yup.array().of(
      yup.object().shape({
        ifscCode: yup
          .string()
          .nullable()
          .required('IFSC Code is required')
          .matches(ifscRegex, 'Invalid IFSC Code'),
        bankAccountNumber: yup
          .string()
          .nullable()
          .required('Bank Account Number is required')
          .matches(accountNumberRegex, 'Please enter valid Account Number')
          .test('bankAccountNumber', 'Account number already used', (value, context) => {
            const {
              options: { context: optionsContext },
            } = context;
            const { banks } = optionsContext || {};
            return banks.filter((bank: Bank) => bank.bankAccountNumber === value).length === 1;
          }),
        bankAccountType: yup
          .string()
          .nullable()
          // .required('Bank Account Type is required')
          .test('bankAccountType', 'Bank Account Type is required', (value, context) => {
            const {
              options: { context: optionsContext },
              createError,
              path,
              parent,
            } = context;
            const fieldValue = value === null ? '' : value;
            const { applicationType, status, banks } = optionsContext || {};
            if (
              applicationType === APPLICATION_TYPE.NON_INDIVIDUAL &&
              !['huf'].includes(applicants ? applicants[0]?.investorType || '' : '') &&
              !fieldValue
            ) {
              return true;
            }
            if (
              applicationType === APPLICATION_TYPE.NON_INDIVIDUAL &&
              fieldValue &&
              ![BankAccountTypeMaster.Current, BankAccountTypeMaster.Savings].includes(fieldValue)
            ) {
              return false;
            } else if (
              fieldValue &&
              applicantStatusMasters[status] !== applicantStatusMasters.NRI &&
              !Object.values(BankAccountTypeMaster).includes(fieldValue)
            ) {
              return false;
            }
            if (
              fieldValue &&
              applicantStatusMasters[status] === applicantStatusMasters.NRI &&
              !Object.values(NRIBankAccountTypeMaster).includes(fieldValue)
            ) {
              return false;
            }
            if (
              fieldValue &&
              applicantStatusMasters[status] === applicantStatusMasters.NRI &&
              banks.filter(
                (bank: Bank) =>
                  Object.values(NRIBankAccountTypeMaster).includes(bank.bankAccountType) &&
                  Object.values(NRIBankAccountTypeMaster).includes(fieldValue) &&
                  bank.bankAccountType != fieldValue
              ).length === 1
            ) {
              return createError({
                message: 'Both Bank Account Type should be same',
                path,
              });
            }

            return !!fieldValue;
          }),
        bankName: yup
          .string()
          .nullable()
          .required('Bank Name is required')
          .matches(stringRegex, 'Please enter valid bank name'),
        bankBranch: yup
          .string()
          .nullable()
          .required('Bank Branch is required')
          .matches(alphaNumericSentence, 'Please enter valid bank branch'),
        city: yup
          .string()
          .nullable()
          .required('Bank City is required')
          .matches(stringRegex, 'Please enter valid city'),
        defaultBankAccount: yup
          .bool()
          .test('defaultBankAccount', 'Please check the default bank account', (value, context) => {
            const {
              options: { context: optionsContext },
            } = context;
            const { banks } = optionsContext || {};
            const isDefaultBankSelected = banks.some((bank: Bank) => bank.defaultBankAccount);
            return isDefaultBankSelected;
          }),
      })
    ),
  });

export const investmentPaymentDetailsSchema = (
  minCommitmentAmount: number,
  maxCommitmentAmount: number,
  minContributionPercentage: number,
  currency: string | null,
  investmentMode: string[],
  percentageMaster: string[],
  monthsMaster: string[],
  createdAt: string,
  schemeCode: string,
  maxHurdleRate: number | null,
  maxPerformanceFee: number | null,
  minHurdleRate: number | null,
  minPerformanceFee: number | null
) =>
  yup.object().shape({
    schemeId: yup.string().required('Fund Scheme is required'),
    modeOfInvestment: yup
      .string()
      .nullable()
      .required('Mode Of Investment is required')
      .oneOf(investmentMode, 'Invalid value for mode of investment'),
    investmentPercentage: yup
      .string()
      .nullable()
      .required('Investment Percentage is required')
      .oneOf(percentageMaster, 'Invalid value for Investment Percentage'),
    investmentMonths: yup
      .string()
      .nullable()
      .when('modeOfInvestment', {
        is: (modeOfInvestment: string) => checkSip([modeOfInvestment]),
        then: yup
          .string()
          .nullable()
          .required('Investment Months is required')
          .oneOf(monthsMaster, 'Invalid value for Investment Months'),
      }),
    planId: yup.string().required('Class Plan is required'),
    commitmentAmount: yup
      .number()
      .nullable()
      .min(
        minCommitmentAmount,
        `Commitment Amount should be greater than or equal to ${currencyConversion(
          minCommitmentAmount,
          currency
        )}`
      )
      .max(
        maxCommitmentAmount,
        `Commitment Amount should be between ${
          currencyConversion(minCommitmentAmount, currency) || '1 Cr'
        } and ${currencyConversion(maxCommitmentAmount, currency) || '2 Cr'}`
      )
      .required('Commitment Amount is required'),
    setupFeePercentage: yup
      .number()
      .nullable()
      .required('Setup Fee Percentage is required')
      .lessThan(101, 'Setup Fee Percentage should be less then 100%'),
    contributionChequeAmount: yup
      .number()
      .nullable()
      .required('Contribution Cheque Amount is required')
      .max(
        yup.ref('commitmentAmount'),
        'Initial Contribution Amount should not be greater than commitment amount'
      )
      .test(
        'contributionChequeAmount',
        `${
          Number(minContributionPercentage) === 100
            ? `Initial Contribution Amount should be equal to commitment amount`
            : `Initial Contribution Amount should be greater than or equal to ${minContributionPercentage}% of commitment amount`
        }`,
        (value, context) => {
          const { parent } = context;
          const { commitmentAmount } = parent;
          return (
            Number(value) >= (Number(minContributionPercentage) * Number(commitmentAmount)) / 100
          );
        }
      ),
    setupFeeTDS: yup
      .number()
      .nullable()
      .min(0, `TDS should be greater than 0`)
      .max(yup.ref('totalSetupFee'), 'TDS should not be greater than Total Setup Fee'),

    // sip: yup
    //   .string()
    //   .nullable()
    //   .required('SIP is required')
    //   .oneOf(Object.keys(SIP_MASTER), 'Invalid value for SIP'),
    modeOfPayment: yup
      .string()
      .nullable()
      .required('Mode of payment is required')
      .oneOf(Object.keys(MODE_OF_PAYMENT_MASTER), 'Invalid value for mode of payment'),
    paymentRefNo: yup
      .string()
      .nullable()
      .when('modeOfPayment', {
        is: (modeOfPayment: string) => isChequeOrRTGS(modeOfPayment),
        then: yup
          .string()
          .nullable()
          .required('Cheque No/UTR No is required')
          .matches(alphaNumeric, 'Invalid Cheque No/UTR No'),
      }),
    neftCode: yup
      .string()
      .nullable()
      .when('modeOfPayment', {
        is: (modeOfPayment: string) => isNEFT(modeOfPayment),
        then: yup
          .string()
          .nullable()
          .required('NEFT Code is required')
          .matches(neftCodeRgx, 'Invalid NEFT Code'),
      }),
    //paymentRefDate: yup.string().nullable().required('Instrument Date is required'),
    placementFee: yup
      .number()
      .nullable()
      .required('Placement Fee is required')
      .min(0, 'Placement Fee must be in between or equal to 0 and 100')
      .max(100, 'Placement Fee must be in between or equal to 0 and 100'),
    distributorFeeType: yup
      .string()
      .nullable()
      // .oneOf(Object.keys(DISTRIBUTION_FEE_TYPE_MASTER), 'Invalid value for Distributor Fee Type')
      .test('distributorFeeType', (value, context) => {
        const {
          options: { context: optionsContext },
          createError,
          path,
          parent,
        } = context;
        const { distributorFeeType } = optionsContext || {};
        const fieldValue = value === undefined ? '' : value;
        if (schemeCode === 'CO') {
          if (!fieldValue) {
            return createError({
              message: `Distributor Fee Type is required`,
              path,
            });
          }
        }
        return true;
      }),
    distributorFee: yup
      .number()
      .nullable()
      .test('distributorFee', (value, context) => {
        const {
          options: { context: optionsContext },
          createError,
          path,
          parent,
        } = context;
        const { distributorFeeType } = optionsContext || {};
        const fieldValue = value === undefined ? '' : value;
        const isFullTrail =
          DISTRIBUTION_FEE_TYPE_MASTER[distributorFeeType] ==
          DISTRIBUTION_FEE_TYPE_MASTER.full_trail;
        const max = isFullTrail ? 100 : 2.5;
        const label = isFullTrail ? DISTRIBUTION_FEE_TYPE_MASTER.full_trail : 'Distribution Fee';
        if (
          DISTRIBUTION_FEE_TYPE_MASTER[distributorFeeType] !=
          DISTRIBUTION_FEE_TYPE_MASTER.upfront_plus_trail
        ) {
          if (fieldValue && (fieldValue < 0 || fieldValue > max)) {
            return createError({
              message: `${label} % should be between 0 and ${max}`,
              path,
            });
          }
        }
        return true;
      }),
    // .min(0, 'Distribution Fee must be in between or equal to 0 and 2.5')
    // .max(2.5, 'Distribution Fee must be in between or equal to 0 and 2.5'),
    upfrontPlusTrail: yup
      .number()
      .nullable()
      .test('upfrontPlusTrail', (value, context) => {
        const {
          options: { context: optionsContext },
          createError,
          path,
          parent,
        } = context;
        const { distributorFeeType } = optionsContext || {};
        const fieldValue = value === undefined ? '' : value;
        if (
          // schemeCode === 'CO' &&
          DISTRIBUTION_FEE_TYPE_MASTER[distributorFeeType] ==
          DISTRIBUTION_FEE_TYPE_MASTER.upfront_plus_trail
        ) {
          // if (!fieldValue && value != 0) {
          //   return createError({
          //     message: `${DISTRIBUTION_FEE_TYPE_MASTER[distributorFeeType]} % is required`,
          //     path,
          //   });
          // }
          if (fieldValue && (fieldValue < 0 || fieldValue > 100)) {
            return createError({
              message: `${DISTRIBUTION_FEE_TYPE_MASTER[distributorFeeType]} % should be between 0 and 100`,
              path,
            });
          }
        }
        return true;
      }),

    // .when([], {
    //   is: () => checkValidationBasedOnDate(createdAt, DistributorFeeValidationStartDate),
    //   then: yup.number().nullable().required('Distribution Fee is required'),
    // }),
    drawnOnBank: yup
      .string()
      .nullable()
      .required('Drawn on bank is required')
      .matches(stringRegex, 'Please enter valid drawn on bank'),
    drawnAccountNumber: yup
      .string()
      .nullable()
      .required('Account number is required')
      .matches(accountNumberRegex, 'Please enter valid account number'),
    drawnBankBranch: yup
      .string()
      .nullable()
      .required('Bank branch is required')
      .matches(alphaNumericSentence, 'Please enter valid bank branch'),
    drawnCity: yup
      .string()
      .nullable()
      .required('City is required')
      .matches(stringRegex, 'Please enter valid city'),
    hurdleRate: yup
      .number()
      .nullable()
      .test('hurdleRate', (value, context) => {
        const { path, createError, parent } = context;
        if (isFieldApplicable(parent?.hurdleRateApplicable)) {
          if (!value && value !== 0) {
            return createError({
              message: 'Hurdle Rate is required',
              path,
            });
          }
          if (
            (value || value === 0) &&
            (value < Number(minHurdleRate) || value > Number(maxHurdleRate))
          ) {
            return createError({
              message: `Hurdle Rate should be in between or equal to ${Number(
                minHurdleRate
              )} and ${Number(maxHurdleRate)}`,
              path,
            });
          }
        }
        return true;
      }),
    performanceFee: yup
      .number()
      .nullable()
      .test('performanceFee', (value, context) => {
        const { path, createError, parent } = context;
        if (isFieldApplicable(parent?.performanceFeeApplicable)) {
          if (!value && value !== 0) {
            return createError({
              message: 'Performance Fee is required',
              path,
            });
          }
          if (
            (value || value === 0) &&
            (value < Number(minPerformanceFee) || value > Number(maxPerformanceFee))
          ) {
            return createError({
              message: `Performance Fee should be in between or equal to ${Number(
                minPerformanceFee
              )} and ${Number(maxPerformanceFee)}`,
              path,
            });
          }
        }
        return true;
      }),
  });

export const documentDetailsSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      documents: yup.array().of(
        yup.object().shape({
          documentsList: yup.array().of(
            yup.object().shape({
              documentName: yup
                .string()
                .nullable()
                .test(
                  'documentName',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, DocumentValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<DocumentValues> & { index: number };
                    const { applicants = [], banks } = optionsContext || ({} as DocumentValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const {
                      required,
                      documentName,
                      documentType,
                      options: optionsDropdown,
                    } = applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    const fieldValue = optionsDropdown && value && optionsDropdown.includes(value);
                    if (optionsDropdown) {
                      if (
                        documentType === 'bankAccountProof' &&
                        !fieldValue &&
                        banks &&
                        banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
                          .length !== 0 &&
                        Number(indexes[0]) === 0
                      ) {
                        return createError({
                          message: `Please select valid value`,
                          path,
                        });
                      }
                      if (documentType === 'bankAccountProof' && Number(indexes[0]) !== 0) {
                        return true;
                      }
                      if (
                        !fieldValue &&
                        required === 'true' &&
                        documentType !== 'bankAccountProof'
                      ) {
                        return createError({
                          message: `Please select valid value`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              documentId: yup
                .string()
                .nullable()
                .test(
                  'documentId',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, DocumentValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<DocumentValues> & { index: number };
                    const { applicants = [], banks } = optionsContext || ({} as DocumentValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const { required, documentName, documentType } =
                      applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    if (required === 'false') {
                      return true;
                    }
                    if (!value) {
                      if (
                        !value &&
                        banks &&
                        banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
                          .length !== 0 &&
                        Number(indexes[0]) === 0 &&
                        documentType === 'bankAccountProof'
                      ) {
                        return createError({
                          message: `Please upload ${documentName}`,
                          path,
                        });
                      }
                      if (!value && required === 'true' && documentType !== 'bankAccountProof') {
                        return createError({
                          message: `Please upload ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              chequeIssuingDate: yup
                .string()
                .nullable()
                .test('chequeIssuingDate', (value, context) => {
                  const { options, createError, path } = context;
                  const { context: optionsContext, parent } =
                    options as InternalOptions<DocumentValues> & { index: number };
                  const { applicants = [] } = optionsContext || ({} as DocumentValues);
                  const { uniqueKey = '' } = parent || {};
                  const indexes = uniqueKey.split('-');
                  const { documentName, documentType } =
                    applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                  const shouldValidate =
                    isBankAccountProof(documentType) && isDocTypeCheque(documentName);
                  if (shouldValidate) {
                    if (!value) {
                      return createError({
                        message: `Cheque Issuing Date is required`,
                        path,
                      });
                    }
                    if (
                      value &&
                      (Date.now() - new Date(value).getTime()) / (24 * 60 * 60 * 1000) >= 90
                    ) {
                      return createError({
                        message: `Invalid value for Cheque Issuing Date`,
                        path,
                      });
                    }
                  }
                  return true;
                }),
            })
          ),
        })
      ),
    })
  ),
  nominees: yup.array().of(
    yup.object().shape({
      nomineedocuments: yup.array().of(
        yup.object().shape({
          documentsList: yup.array().of(
            yup.object().shape({
              documentName: yup
                .string()
                .nullable()
                .test(
                  'documentName',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, DocumentValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<DocumentValues> & { index: number };
                    const { nominees = [] } = optionsContext || ({} as DocumentValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const {
                      required,
                      documentName,
                      documentType,
                      options: optionsDropdown,
                    } = nominees[indexes[0]].nomineedocuments[indexes[1]].documentsList[indexes[2]];
                    const fieldValue = optionsDropdown && value && optionsDropdown.includes(value);
                    if (optionsDropdown) {
                      if (!fieldValue && required === 'true') {
                        return createError({
                          message: `Please Select ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              documentId: yup
                .string()
                .nullable()
                .test(
                  'documentId',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, DocumentValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<DocumentValues> & { index: number };
                    const { nominees = [], banks } = optionsContext || ({} as DocumentValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const { required, documentName, documentType } =
                      nominees[indexes[0]].nomineedocuments[indexes[1]].documentsList[indexes[2]];
                    if (required === 'false') {
                      return true;
                    }
                    if (!value && required === 'true') {
                      return createError({
                        message: `Please upload ${documentName}`,
                        path,
                      });
                    }
                    return true;
                  }
                ),
            })
          ),
        })
      ),
    })
  ),
  // applicants: yup.array().of(
  //   yup.object().shape({
  //     documents: yup.object().shape({
  //       // identityProof: yup.object().shape({
  //       //   documentName: yup.string().required('Please select identity proof'),
  //       //   documentId: yup.string().required('Please upload Identity Proof'),
  //       // }),
  //       // addressProof: yup.object().shape({
  //       //   documentName: yup.string().required('Please select Address Proof'),
  //       //   documentId: yup.string().required('Please upload Address Proof'),
  //       // }),
  //       bankAccountProof: yup.object().shape({
  //         documentName: yup
  //           .string()
  //           .test('documentName', 'Please select Bank Account Proof', (value, context) =>
  //             DocumentRequiredForPennyDrop(value, context)
  //           ),

  //         documentId: yup
  //           .string()
  //           .test('documentId', 'Please upload Bank Account Proof', (value, context) =>
  //             DocumentRequiredForPennyDrop(value, context)
  //           ),
  //       }),
  //       poaNotarized: yup.object().shape({
  //         documentId: yup
  //           .string()
  //           .test('documentId', 'Please upload POA Notarized Document', (value, context) =>
  //             POADocumentValidation(value, context, 'poaNotarized')
  //           ),
  //       }),
  //       investorsConsent: yup.object().shape({
  //         documentId: yup
  //           .string()
  //           .test('documentId', "Please upload Investor's Consent Document", (value, context) =>
  //             POADocumentValidation(value, context)
  //           ),
  //       }),
  //       fatca: yup.object().shape({
  //         documentId: yup
  //           .string()
  //           .test('documentId', 'Please upload FATCA Document', (value, context) =>
  //             POADocumentValidation(value, context)
  //           ),
  //       }),
  //     }),
  //   })
  // ),
});

export const distributorsValidationSchema = (
  selectedDistributor: SubDistributor[],
  distributors: Distributor[],
  createdAt: string
) =>
  yup.object().shape({
    //role: useSelector((store: RootStateType) => store.auth),
    // distributorId: yup
    //   .string()
    //   .nullable()
    //   .when('loginType', {
    //     is: (loginType: string) => loginType === 'distributor' && !!distributors.length,
    //     then: yup.string().nullable().required('Please select a distributor code'),
    //   }),
    // subdistributorId: yup
    //   .string()
    //   .nullable()
    //   .when(['loginType', 'distributorId'], {
    //     is: () => 'distributor' && !!selectedDistributor.length,
    //     then: yup.string().nullable().required("Please select a distributor's rm name - code"),
    //   }),
    distributorName: yup
      .string()
      .nullable()
      .matches(defaultRegexWithSingleLine, 'Invalid Distributor Name')
      .when('loginType', {
        is: (loginType: string) => loginType === 'distributor',
        then: yup.string().nullable().required('Distributor name is required'),
      }),
    distributorArnCode: yup.string().nullable(),
    // .matches(arnCodeRegex, 'Invalid Distributor ARN Code Ex:- ARN-12345'),
    //selectedDistributor.length
    distributorRmName: yup
      .string()
      .nullable()
      .when('loginType', {
        is: (loginType: string) =>
          loginType === 'distributor' &&
          checkValidationBasedOnDate(createdAt, distributorRmNameStartDate),
        then: yup.string().nullable().required('Distributor RM Name is required'),
      }),
  });

export const userManagementRmSchema = yup.object().shape({
  name: yup.string().nullable().required('RM Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .min(8, 'Invalid Mobile Number')
    .max(16, 'Invalid Mobile Number')
    .matches(phoneRegExp, 'Invalid Mobile Number')
    .required('Mobile Number is required'),
  //   phone: yup
  //   .string()
  //   .nullable()
  //   .test('phone', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === parent.countryNameAndCode) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Phone is required',
  //         path,
  //       });
  //     }
  //     if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }
  //     if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
});

export const DistributorSchema = yup.object().shape({
  name: yup.string().nullable().required('Distributor Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .when('type', {
      is: (value: string) => value === 'individual',
      then: yup.string().required('Email is required'),
    }),
  phone: yup
    .string()
    .nullable()
    .min(8, 'Invalid Mobile Number')
    .max(16, 'Invalid Mobile Number')
    .matches(phoneRegExp, 'Invalid Mobile Number')
    .when('type', {
      is: (value: string) => value === 'individual',
      then: yup.string().nullable().required('Mobile Number is required'),
    }),
  //   phone: yup
  //   .string()
  //   .nullable()
  //   .test('phone', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === parent.countryNameAndCode) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value && parent.type=== 'individual') {
  //       return createError({
  //         message: 'Phone is required',
  //         path,
  //       });
  //     }
  //     if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }
  //     if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value&&parent.type=== 'individual') {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  arnCode: yup.string().nullable().matches(arnCodeRegex, 'Invalid Distributor Code Ex:- ARN-12345'),
  // .required('ARN Code is required'),
  rmId: yup
    .string()
    .nullable()
    .when('type', {
      is: (value: string) => value === 'individual',
      then: yup.string().nullable().required('RM Name is required'),
    }),
  // pincode: yup.string().nullable().required('Please Enter Pincode'),
  // buildingNo: yup.string().nullable().required('Please Enter Building Number'),
  // streetName: yup.string().nullable().required('Please Enter Street Name'),
  // city: yup.string().nullable().required('Please Enter City'),
  // state: yup.string().nullable().required('Please Enter State'),
  // country: yup.string().nullable().required('Please Enter Country'),
});

export const TrusteeAndFundManagerSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .required('Mobile Number is required')
    .min(8, 'Invalid Mobile number')
    .max(16, 'Invalid Mobile number')
    .matches(phoneRegExp, 'Invalid Mobile number'),
  //   phone: yup
  //   .string()
  //   .nullable()
  //   .test('phone', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === parent.countryNameAndCode) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Phone is required',
  //         path,
  //       });
  //     }
  //     if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }
  //     if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  dateOfBirth: yup
    .string()
    .nullable()
    .test(
      'dateOfBirth',
      'Age should be greater than 18',
      (dateOfBirth) => !isMinor(dateOfBirth || '')
    ),
  leegalityName: yup.string().nullable().required('Leegality Name is required'),
  // .required('Date of Birth is required'),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  // pincode: yup.string().required('Please Enter Pincode'),
  // buildingNo: yup.string().required('Please Enter Building Number'),
  // streetName: yup.string().required('Please Enter Street Name'),
  // city: yup.string().required('Please Enter City'),
  // state: yup.string().required('Please Enter State'),
  // country: yup.string().required('Please Enter Country'),
});

export const aifApproverSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .required('Mobile Number is required')
    .min(8, 'Invalid Mobile Number')
    .max(16, 'Invalid Mobile Number')
    .matches(phoneRegExp, 'Invalid Mobile Number'),
  //   phone: yup
  //   .string()
  //   .nullable()
  //   .test('phone', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === parent.countryNameAndCode) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Phone is required',
  //         path,
  //       });
  //     }
  //     if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }
  //     if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // pincode: yup.string().required('Please Enter Pincode'),
  // buildingNo: yup.string().required('Please Enter Building Number'),
  // streetName: yup.string().required('Please Enter Street Name'),
  // city: yup.string().required('Please Enter City'),
  // state: yup.string().required('Please Enter State'),
  // country: yup.string().required('Please Enter Country'),
});
export const amcApproverSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .required('Mobile Number is required')
    .min(8, 'Invalid Mobile Number')
    .max(16, 'Invalid Mobile Number')
    .matches(phoneRegExp, 'Invalid Mobile Number'),
});

export const addFundManagerSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .required('Mobile Number is required')
    .min(8, 'Invalid mobile number')
    .max(16, 'Invalid mobile number')
    .matches(phoneRegExp, 'Invalid mobile number'),
  //   phone: yup
  //   .string()
  //   .nullable()
  //   .test('phone', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === parent.countryNameAndCode) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Phone is required',
  //         path,
  //       });
  //     }
  //     if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }
  //     if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  leegalityName: yup.string().nullable().required('Leegality Name is required'),
  // pincode: yup.string().required('Please Enter Pincode'),
  // buildingNo: yup.string().required('Please Enter Building Number'),
  // streetName: yup.string().required('Please Enter Street Name'),
  // city: yup.string().required('Please Enter City'),
  // state: yup.string().required('Please Enter State'),
  // country: yup.string().required('Please Enter Country'),
});

export const AuthorisedSignatoryAndPOASchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .min(8, 'Invalid Mobile number')
    .max(16, 'Invalid Mobile number')
    .matches(phoneRegExp, 'Invalid Mobile number')
    .required('Mobile Number is required'),
  //   phone: yup
  //   .string()
  //   .nullable()
  //   .test('phone', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === parent.countryNameAndCode) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Phone is required',
  //         path,
  //       });
  //     }
  //     if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }
  //     if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  // distributorId: yup.string().required('Please Enter Distridutor Id'),
  // amcId: yup.string().required('Please Enter AmcId'),
  // pincode: yup.string().nullable().required('Please Enter Pincode'),
  // buildingNo: yup.string().nullable().required('Please Enter Building Number'),
  // streetName: yup.string().nullable().required('Please Enter Street Name'),
  // city: yup.string().nullable().required('Please Enter City'),
  // state: yup.string().nullable().required('Please Enter State'),
  // country: yup.string().nullable().required('Please Enter Country'),
});

export const DistributorRmSchema = yup.object().shape({
  name: yup.string().nullable().required("Distributor's RM name is required"),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .min(8, 'Invalid Mobile Number')
    .max(16, 'Invalid Mobile Number')
    .matches(phoneRegExp, 'Invalid Mobile Number')
    .required('Mobile Number is required'),
  //   phone: yup
  //   .string()
  //   .nullable()
  //   .test('phone', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === parent.countryNameAndCode) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Phone is required',
  //         path,
  //       });
  //     }
  //     if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }
  //     if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Phone number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),
  //distributors_RM_Code: yup.string().required('Please Enter Distributor RM code'),
  rmId: yup.string().nullable().required("AMC's RM name is required"),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  // pincode: yup.string().nullable().required('Please Enter Pincode'),
  // buildingNo: yup.string().nullable().required('Please Enter Building Number'),
  // streetName: yup.string().nullable().required('Please Enter Street Name'),
  // city: yup.string().nullable().required('Please Enter City'),
  // state: yup.string().nullable().required('Please Enter State'),
  // country: yup.string().nullable().required('Please Enter Country'),
});

// name,
// email,
// countryCode,
// phone,
// panNumber,
// distributors_RM_Code,
// rmId,
// distributorId,
// pincode,
// buildingNo,
// streetName,
// city,
// state,
// country,

// pan: yup
// .string()
// .nullable()
// .uppercase()
// .length(10, 'PAN must be exactly 10 characters')
// .matches(individualPanRegex, 'Only individual PANs are allowed')
// .test('pan', (value, context) => {
//   const { path, createError, options } = context;
//   const { context: optionsContext } = options as InternalOptions<Groups[]>;
//   const authorisedSignatoriesPanNumbers = optionsContext
//     ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.pan))
//     .flat();
//   if (!value) {
//     return createError({
//       message: 'PAN is required',
//       path,
//     });
//   }
//   if (authorisedSignatoriesPanNumbers && authorisedSignatoriesPanNumbers.includes(value)) {
//     return createError({
//       message:
//         'There is already same pan number for an Authorised Signatory associated with this application',
//       path,
//     });
//   }

//   return true;
// }),

// mobile: yup
// .string()
// .nullable()
// .min(8, 'Invalid Mobile Number')
// .max(16, 'Invalid Mobile Number')
// .matches(phoneRegExp, 'Invalid Mobile Number')
// .test('mobile', (value, context) => {
//   const { path, createError, options } = context;
//   const { context: optionsContext } = options as InternalOptions<Groups[]>;
//   const authorisedSignatoriesMobileNumbers = optionsContext
//     ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.mobile))
//     .flat();
//   if (!value) {
//     return createError({
//       message: 'Mobile Number is required',
//       path,
//     });
//   }
//   if (
//     authorisedSignatoriesMobileNumbers &&
//     authorisedSignatoriesMobileNumbers.includes(value)
//   ) {
//     return createError({
//       message:
//         'There is already same mobile number for an Authorised Signatory associated with this application',
//       path,
//     });
//   }

//   return true;
// }),
// email: yup
// .string()
// .nullable()
// .matches(emailRegex, 'Invalid Email ID')
// .test('email', (value, context) => {
//   const { path, createError, options } = context;
//   const { context: optionsContext } = options as InternalOptions<Groups[]>;
//   const authorisedSignatoriesEmailID = optionsContext
//     ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.email))
//     .flat();
//   if (!value) {
//     return createError({
//       message: 'Email ID is required',
//       path,
//     });
//   }
//   if (authorisedSignatoriesEmailID && authorisedSignatoriesEmailID.includes(value)) {
//     return createError({
//       message:
//         'There is already same Email ID for an Authorised Signatory associated with this application',
//       path,
//     });
//   }

//   return true;
// }),
export const amcAdminSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  phone: yup
    .string()
    .nullable()
    .required('Mobile Number is required')
    .min(8, 'Invalid Mobile Number')
    .max(16, 'Invalid Mobile Number')
    .matches(phoneRegExp, 'Invalid Mobile Number'),
});

export const NonIndividualContributorValidationSchema = (brokers: Broker[], createdAt: string) =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        name: yup.string().nullable().required('Name Of Entity is required'),
        cityOfIncorporation: yup
          .string()
          .nullable()
          .required('Place of Registration/Incorporation is required'),
        dateOfBirth: yup
          .string()
          .nullable()
          .required('Date of Registration/Incorporation is required'),
        dlclId: yup
          .string()
          .nullable()
          .required('Demat Account Details (for allotment of units) is required')
          .oneOf(
            Object.keys(DLCLMasters),
            'Invalid value for Demat Account Details (for allotment of units)'
          ),
        dpId: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getdpIdField(dlclId || ''),
            then: yup
              .string()
              .nullable()
              .test('dpId', (value, context) => {
                const { path, createError, parent } = context;
                if (!checkValidationBasedOnDate(createdAt, DematDetialsValidationModified)) {
                  if (!value) {
                    return createError({
                      message: `${isCDSL(parent.dlclId) ? 'DPCL ID' : 'DP ID'} is required`,
                      path,
                    });
                  }

                  if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
                    if (value && !isCDSL(parent.dlclId) && !dpIdRegex.test(value)) {
                      return createError({
                        message: `DP ID should consist of 8 digits and must start with 'IN'`,
                        path,
                      });
                    }

                    if (value && isCDSL(parent.dlclId)) {
                      if (
                        !dpIdNumberRegex.test(value) &&
                        checkValidationBasedOnDate(createdAt, dpIdFieldValidationDate)
                      ) {
                        return createError({
                          message: 'DPCL ID should consist of 16 numeric digits',
                          path,
                        });
                      }
                      if (
                        !checkValidationBasedOnDate(createdAt, dpIdFieldValidationDate) &&
                        !(cdslRegex.test(value) || dpIdNumberRegex.test(value))
                      ) {
                        return createError({
                          message: 'DPCL ID should consist of 8 or 16 numeric digits',
                          path,
                        });
                      }
                      return true;
                    }
                    return true;
                  }
                }
                if (checkValidationBasedOnDate(createdAt, DematDetialsValidationModified)) {
                  if (!value) {
                    return createError({
                      message: `DP ID is required`,
                      path,
                    });
                  }
                  if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
                    if (value && isCDSL(parent.dlclId) && !dpIdRegexForCDSL.test(value)) {
                      return createError({
                        message: `DP ID should consist of 8 numeric digits`,
                        path,
                      });
                    }

                    if (value && !isCDSL(parent.dlclId) && !dpIdRegexForNSDL.test(value)) {
                      return createError({
                        message: `DP ID should consist of 8 digits and must start with 'IN'`,
                        path,
                      });
                    }
                    return true;
                  }
                  return true;
                }
                return true;
              }),
          }),
        clId: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getclIdField(dlclId || '', createdAt),
            then: yup
              .string()
              .nullable()
              .test('clId', (value, context) => {
                const { path, createError, options } = context;
                if (!value) {
                  return createError({
                    message: 'CL ID is required',
                    path,
                  });
                }
                if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
                  // if (value && !cdslRegex.test(value)) {
                  if (value && !clIdRegex.test(value)) {
                    return createError({
                      message: 'CL ID should consist of 8 numeric digits',
                      path,
                    });
                  }
                }
                return true;
              }),
          }),
        nameOfBroker: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getdpIdField(dlclId || ''),
            then: yup
              .string()
              .nullable()
              .test('nameOfBroker', (value, context) => {
                const { path, createError } = context;
                const brokerList = brokers.map((broker) => broker.key);
                if (!value) {
                  return true;
                }
                if (value && !brokerList.includes(value)) {
                  return createError({
                    message: 'Invalid value for Name of Broker/Depository Participant (DP)',
                    path,
                  });
                }
                return true;
              }),
          }),
        dematName: yup
          .string()
          .nullable()
          .when('dlclId', {
            is: (dlclId: string) => getdpIdField(dlclId || ''),
            then: yup.string().nullable().required('Name as per the Demat Account is required'),
          }),
        ckyc_selection_options: yup
          .string()
          .nullable()
          .required('Ckyc required')
          .oneOf(Object.keys(CKYC_SELECTION_OPTIONS_OBJECT), 'Invalid Value'),
        ckycNo: yup
          .string()
          .nullable()
          .test('ckycNo', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const {
              options: { context: optionsContext },
              createError,
              path,
              parent,
            } = context;
            //eslint-disable-next-line
            const { applicants } = optionsContext || {};
            if (!fieldValue && isCkycMandatory(parent?.ckyc_selection_options || '')) {
              return createError({
                message: 'CKYC No./CKYC Acknowledge No./KIN No is required',
                path,
              });
            } else if (fieldValue) {
              if (!ckycNumberRegex.test(fieldValue)) {
                return createError({
                  message: 'Invalid CKYC No./CKYC Acknowledge No./KIN No',
                  path,
                });
                // } else if (!numberRegex.test(fieldValue)) {
                //   return createError({
                //     message: 'CKYC No./CKYC Acknowledge No./KIN No allows only digits',
                //     path,
                //   });
                // } else if (
                //   applicants.filter((applicant: Applicant) => applicant.ckycNo === fieldValue)
                //     .length > 1
                // ) {
                //   return createError({
                //     message:
                //       'There is already same CKYC Number for an applicant associated with this application',
                //     path,
                //   });
              }
            }
            return true;
          }),
        panNo: yup
          .string()
          .nullable()
          .uppercase()
          .length(10, 'PAN must be exactly 10 characters')
          .matches(nonIndividualPanRegex, 'Invalid PAN')
          .required('PAN is required'),
        investorType: yup
          .string()
          .nullable()
          .oneOf(Object.keys(investorTypeMasters), 'Invalid value for Investor Type')
          .required('Please Select Investor Type'),
        otherInvestorType: yup
          .string()
          .nullable()
          .when('investorType', {
            is: 'others',
            then: yup.string().nullable().required('Please Specify Other Investor Type'),
          }),
        netWorth: yup
          .string()
          .nullable()
          .test('netWorth', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError } = context;
            if (!fieldValue) {
              return createError({
                message: 'Net Worth is required',
                path,
              });
            }
            if (!amountRegex.test(fieldValue)) {
              return createError({
                message: 'Invalid amount',
                path,
              });
            }
            return true;
          }),
        grossAnnualIncome: yup
          .string()
          .nullable()
          .oneOf(getGrossAnnualMasters(createdAt || ''), 'Invalid value for Gross Annual Income')
          .required('Gross Annual Income is required'),
        amcCallVerified: yup
          .string()
          .nullable()
          .required('AMC Call Verified is required')
          .oneOf(Object.keys(YES_NO_MASTER), 'Invalid value for AMC Call Verified'),
        sourceOfFunds: yup
          .string()
          .nullable()
          // .required('Source of funds is required')
          .oneOf(Object.keys(SOURCE_OF_FUNDS_MASTER), 'Invalid value for source of funds'),
        otherSourceOfFunds: yup
          .string()
          .nullable()
          .when('sourceOfFunds', {
            is: (sourceOfFunds: string) => sourceOfFunds && isOtherSourceOfFund(sourceOfFunds),
            then: yup.string().nullable().required('Other source of funds is required'),
          }),
      })
    ),
  });

const validateNonIndividualPincodeField = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>,
  addressType: string
) => {
  const fieldValue = value === undefined ? '' : value;
  const { options, path, createError, parent } = context;
  const { context: optionsContext, index } =
    options as InternalOptions<NonIndividualContactValues> & {
      index: number;
    };
  const { applicants = [] } = optionsContext || {};
  if (!fieldValue && (addressType === 'permanent' || addressType === 'correspondence')) {
    return createError({
      message: 'Pincode is required',
      path,
    });
  }
  if (fieldValue && parent.country?.toLowerCase() === 'india' && !indianPin.test(fieldValue)) {
    return createError({
      message: 'Pincode code should be 6 digit code',
      path,
    });
  }
  if (
    fieldValue &&
    parent.country?.toLowerCase() !== 'india' &&
    !pinCodeRegexOtherThanIndia.test(fieldValue)
  ) {
    return createError({
      message: 'Invalid Pincode',
      path,
    });
  }
  return true;
};

export const nonIndividualContactDetailsSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      contactperson: yup.object().shape({
        address1: yup
          .string()
          .nullable()
          .matches(
            addressRegex,
            "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
          ),
        // .required('Address line 1 is required'),
        address2: yup
          .string()
          .nullable()
          .matches(
            addressRegex,
            "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
          ),
        // .required('Address line 2 is required'),

        landLineNumber: yup
          .string()
          .nullable()
          .test('landLineNumber', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent } = context;
            if (!fieldValue && parent.stdCode) {
              return createError({
                message: 'Please enter Landline number',
                path,
              });
            } else if (parent.landLineNumber && !numberRegex.test(parent.landLineNumber)) {
              return createError({
                message: 'Please enter valid Landline Number',
                path,
              });
            }
            return true;
          }),
        stdCode: yup
          .string()
          .nullable()
          .test('stdCode', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent } = context;
            if (!fieldValue && parent.landLineNumber) {
              return createError({
                message: 'Please enter STD Code',
                path,
              });
            } else if (parent.stdCode && !numberRegex.test(parent.stdCode)) {
              return createError({
                message: 'Please enter valid STD Code',
                path,
              });
            }
            return true;
          }),

        city: yup.string().nullable(),
        // .required('City is required'),
        state: yup.string().nullable(),
        // .required('State is required'),
        country: yup
          .string()
          .nullable()
          .test('country', (value, context) => {
            const { options, createError, path } = context;
            const { context: optionsContext } =
              options as InternalOptions<NonIndividualContactValues>;
            const { countryDropdown = [] } = optionsContext || {};
            // if (!value) {
            //   return createError({
            //     message: 'Country is required',
            //     path,
            //   });
            // }
            if (value && !countryDropdown.includes(value)) {
              return createError({
                message: 'Invalid value for Country',
                path,
              });
            }
            return true;
          }),
        pincode: yup
          .string()
          .nullable()
          .test('pincode', (value, context) =>
            validateNonIndividualPincodeField(value, context, 'contactPerson')
          ),
        name: yup.string().nullable().required('Name is required'),
        contactPersonDesignation: yup
          .string()
          .nullable()
          .required('Designation is required')
          .matches(stringRegex, 'Invalid Designation'),
        email: yup
          .string()
          .nullable()
          .matches(emailRegex, 'Invalid Email ID')
          .required('Email is required'),
        mobile: yup
          .string()
          .nullable()
          .test('mobile', (value, context) => {
            const { createError, path, parent } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === parent.countryNameAndCode) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            if (!value) {
              return createError({
                message: 'Mobile is required',
                path,
              });
            }
            if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }
            if (!isValidPhoneNumber(value, codesList as CountryCode)) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }

            return true;
          }),
        countryNameAndCode: yup
          .string()
          .nullable()
          .test('countryNameAndCode', (value, context) => {
            const { createError, path, parent } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === value) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            if (!value) {
              return createError({
                message: 'Country Code is required',
                path,
              });
            }
            if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }

            return true;
          }),
      }),
      address: yup.object().shape({
        correspondence: yup.object().shape({
          address1: yup
            .string()
            .nullable()
            .matches(
              addressRegex,
              "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
            )
            .required('Address line 1 is required'),
          address2: yup
            .string()
            .nullable()
            .matches(
              addressRegex,
              "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
            )
            .test('address2', 'Address line 2 is required', (value, context) => {
              const { options } = context;
              const { context: optionsContext, index } = options as InternalOptions<Values> & {
                index: number;
              };
              const { applicants = [] } = optionsContext || {};
              const currentApplicant = applicants[index] || {};
              const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
              if (!fetchedFromKRA && !value) {
                return false;
              }
              return true;
            }),
          pincode: yup
            .string()
            .nullable()
            .test('pincode', (value, context) =>
              validateNonIndividualPincodeField(value, context, 'correspondence')
            ),
          city: yup.string().nullable().required('City is required'),
          state: yup.string().nullable().required('State is required'),
          country: yup
            .string()
            .nullable()
            .test('country', (value, context) => {
              const { options, createError, path } = context;
              const { context: optionsContext } =
                options as InternalOptions<NonIndividualContactValues>;
              const { countryDropdown = [] } = optionsContext || {};
              if (!value) {
                return createError({
                  message: 'Country is required',
                  path,
                });
              }
              if (!countryDropdown.includes(value)) {
                return createError({
                  message: 'Invalid value for Country',
                  path,
                });
              }
              return true;
            }),
        }),
        permanent: yup.object().shape({
          address1: yup
            .string()
            .nullable()
            .matches(
              addressRegex,
              "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
            )
            .test('address1', 'Address line 1 is required', (value, context) =>
              validatePermanentAddressFields(value, context, APPLICATION_TYPE.NON_INDIVIDUAL)
            ),
          address2: yup
            .string()
            .nullable()
            .matches(
              addressRegex,
              "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
            )
            // .test('address2', 'Address2 is required', (value, context) =>
            //   validatePermanentAddressFields(value, context, APPLICATION_TYPE.NON_INDIVIDUAL)
            // ),
            .test('address2', 'Address line 2 is required', (value, context) => {
              const { options } = context;
              const { context: optionsContext, index } = options as InternalOptions<Values> & {
                index: number;
              };
              const { applicants = [] } = optionsContext || {};
              const currentApplicant = applicants[index] || {};
              const { fetchedFromKRA = null } = currentApplicant.address.permanent || {};
              if (!fetchedFromKRA) {
                return validatePermanentAddressFields(
                  value,
                  context,
                  APPLICATION_TYPE.NON_INDIVIDUAL
                );
              }
              return true;
            }),
          pincode: yup
            .string()
            .nullable()
            .test('pincode', (value, context) => {
              const { options } = context;
              const { context: optionsContext, index } = options as InternalOptions<Values> & {
                index: number;
              };
              const { applicants = [] } = optionsContext || {};
              const currentApplicant = applicants[index] || {};
              const { permanentAddressSameAsCorresponding = false } =
                currentApplicant.address.correspondence || {};
              if (!permanentAddressSameAsCorresponding) {
                return validateNonIndividualPincodeField(value, context, 'permanent');
              }
              return true;
            }),
          city: yup
            .string()
            .nullable()
            .test('city', 'City is required', (value, context) =>
              validatePermanentAddressFields(value, context, APPLICATION_TYPE.NON_INDIVIDUAL)
            ),
          state: yup
            .string()
            .nullable()
            .test('state', 'State is required', (value, context) =>
              validatePermanentAddressFields(value, context, APPLICATION_TYPE.NON_INDIVIDUAL)
            ),
          country: yup
            .string()
            .nullable()
            .test('country', (value, context) => {
              const { options, createError, path } = context;
              const { context: optionsContext, index } =
                options as InternalOptions<NonIndividualContactValues> & {
                  index: number;
                };
              const { applicants = [], countryDropdown = [] } = optionsContext || {};
              const currentApplicant = applicants[index] || {};
              const { permanentAddressSameAsCorresponding = false } =
                currentApplicant.address.correspondence || {};
              if (!permanentAddressSameAsCorresponding) {
                if (!value) {
                  return createError({
                    message: 'Country is required',
                    path,
                  });
                }
                if (!countryDropdown.includes(value)) {
                  return createError({
                    message: 'Invalid value for Country',
                    path,
                  });
                }
              }
              return true;
            }),
          // .test('country', 'Country is required', (value, context) =>
          //   validatePermanentAddressFields(value, context)
          // ),
        }),
      }),
    })
  ),
});

export const nonIndividualDocumentDetailsSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      documents: yup.array().of(
        yup.object().shape({
          documentsList: yup.array().of(
            yup.object().shape({
              documentName: yup
                .string()
                .nullable()
                .test(
                  'documentName',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, NonIndividualDocValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<NonIndividualDocValues> & { index: number };
                    const { applicants = [], banks } =
                      optionsContext || ({} as NonIndividualDocValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const {
                      required,
                      documentName,
                      documentType,
                      options: optionsDropdown,
                    } = applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    const fieldValue = optionsDropdown && value && optionsDropdown.includes(value);
                    if (optionsDropdown) {
                      if (
                        documentType === 'bankAccountProof' &&
                        !fieldValue &&
                        banks &&
                        banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
                          .length !== 0
                      ) {
                        return createError({
                          message: `Please select valid value`,
                          path,
                        });
                      }
                      if (
                        !fieldValue &&
                        required === 'true' &&
                        documentType !== 'bankAccountProof'
                      ) {
                        return createError({
                          message: `Please select valid value`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              documentId: yup
                .string()
                .nullable()
                .test(
                  'documentId',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, NonIndividualDocValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<NonIndividualDocValues> & { index: number };
                    const { applicants = [], banks } =
                      optionsContext || ({} as NonIndividualDocValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const { required, documentName, documentType } =
                      applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    if (required === 'false') {
                      return true;
                    }
                    if (!value) {
                      if (
                        !value &&
                        documentType === 'bankAccountProof' &&
                        banks &&
                        banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
                          .length !== 0
                      ) {
                        return createError({
                          message: `Please upload ${documentName}`,
                          path,
                        });
                      }
                      if (required === 'true' && documentType !== 'bankAccountProof') {
                        return createError({
                          message: `Please upload ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              chequeIssuingDate: yup
                .string()
                .nullable()
                .test('chequeIssuingDate', (value, context) => {
                  const { options, createError, path } = context;
                  const { context: optionsContext, parent } =
                    options as InternalOptions<DocumentValues> & { index: number };
                  const { applicants = [] } = optionsContext || ({} as DocumentValues);
                  const { uniqueKey = '' } = parent || {};
                  const indexes = uniqueKey.split('-');
                  const { documentName, documentType } =
                    applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                  const shouldValidate =
                    isBankAccountProof(documentType) && isDocTypeCheque(documentName);
                  if (shouldValidate) {
                    if (!value) {
                      return createError({
                        message: `Cheque Issuing Date is required`,
                        path,
                      });
                    }
                    if (
                      value &&
                      (Date.now() - new Date(value).getTime()) / (24 * 60 * 60 * 1000) >= 90
                    ) {
                      return createError({
                        message: `Invalid value for Cheque Issuing Date`,
                        path,
                      });
                    }
                  }
                  return true;
                }),
            })
          ),
        })
      ),
    })
  ),
});

export const nonIndividualAuthorisedSignatories = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  pan: yup
    .string()
    .nullable()
    .uppercase()
    .length(10, 'PAN must be exactly 10 characters')
    .matches(individualPanRegex, 'Only individual PANs are allowed')
    .test('pan', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<Groups[]>;
      const authorisedSignatoriesPanNumbers = optionsContext
        ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.pan))
        .flat();
      if (!value) {
        return createError({
          message: 'PAN is required',
          path,
        });
      }
      if (authorisedSignatoriesPanNumbers && authorisedSignatoriesPanNumbers.includes(value)) {
        return createError({
          message:
            'There is already same pan for an Authorised Signatory associated with this application',
          path,
        });
      }

      return true;
    }),
  mobile: yup
    .string()
    .nullable()
    .test('mobile', (value, context) => {
      const { path, createError, options, parent } = context;
      const { context: optionsContext } = options as InternalOptions<Groups[]>;
      const authorisedSignatoriesMobileNumbers = optionsContext
        ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.mobile))
        .flat();
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Mobile Number is required',
          path,
        });
      }
      if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (!isValidPhoneNumber(value, codesList as CountryCode)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (
        authorisedSignatoriesMobileNumbers &&
        authorisedSignatoriesMobileNumbers.includes(value)
      ) {
        return createError({
          message:
            'There is already same mobile number for an Authorised Signatory associated with this application',
          path,
        });
      }

      return true;
    }),

  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid Email ID')
    .test('email', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<Groups[]>;
      const authorisedSignatoriesEmailID = optionsContext
        ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.email))
        .flat();
      if (!value) {
        return createError({
          message: 'Email ID is required',
          path,
        });
      }
      if (authorisedSignatoriesEmailID && authorisedSignatoriesEmailID.includes(value)) {
        return createError({
          message:
            'There is already same Email ID for an Authorised Signatory associated with this application',
          path,
        });
      }

      return true;
    }),
  designation: yup.string().nullable().required('Designation is required'),
});

const fieldValidation = (
  value: string | undefined | null | number,
  context: yup.TestContext<Record<string, ubo>>,
  mes: string
) => {
  const fieldValue = value === undefined ? '' : value;
  const { path, createError, parent } = context;
  if (!fieldValue && !parent.isFetchData) {
    return createError({
      message: `${mes} is required`,
      path,
    });
  }
  return true;
};

export const nonIndividualUbo = yup.object().shape({
  panNumber: yup
    .string()
    .nullable()
    .uppercase()
    .test('panNumber', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<ubo[]>;

      const uboPanNumbers = optionsContext?.map((ubo) => ubo.panNumber);
      if (!value) {
        return createError({
          message: 'Taxpayer ID Number/PAN/Equivalent ID Number is required',
          path,
        });
      }
      if (value && !alphaNumeric.test(value)) {
        return createError({
          message: 'Invalid Taxpayer ID Number/PAN/Equivalent ID Number',
          path,
        });
      }
      if (uboPanNumbers && uboPanNumbers.includes(value)) {
        return createError({
          message:
            'There is already same Taxpayer ID Number/PAN/Equivalent ID Number for an Ultimate Beneficiary Ownership (UBO) associated with this application',
          path,
        });
      }

      return true;
    }),

  dob: yup
    .string()
    .nullable()
    .test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if ((INVESTOR_CONSENT_FLOW && !parent.isFetchData) || !INVESTOR_CONSENT_FLOW) {
        if (!fieldValue) {
          return createError({
            message: 'Date of birth is required',
            path,
          });
        }
        if (
          parent.panNumber &&
          individualPanRegex.test(parent.panNumber) &&
          isMinor(fieldValue || '')
        ) {
          return createError({
            message: 'Age should be greater than 18',
            path,
          });
        }
        if (
          parent.panNumber &&
          individualPanRegex.test(parent.panNumber) &&
          maxAge(fieldValue || '')
        ) {
          return createError({
            message: 'Age should be less than 125',
            path,
          });
        }
      }
      return true;
    }),
  name: yup
    .string()
    .nullable()
    .test('name', (value, context) => {
      return fieldValidation(value, context, 'Name');
    }),
  identificationType: yup
    .string()
    .nullable()
    .test('identificationType', (value, context) => {
      return fieldValidation(value, context, 'Identification Type');
    }),
  typeOfUBO: yup
    .string()
    .nullable()
    .oneOf(Object.keys(UboTypeMaster), 'Invalid value for UBO Type'),
  type: yup
    .string()
    .nullable()
    .oneOf(Object.keys(UboCategoryMaster), 'Invalid value for UBO Category')
    .test('type', (value, context) => {
      return fieldValidation(value, context, 'UBO Category');
    }),
  percentageOfBeneficialInterest: yup
    .number()
    .nullable()
    .test('percentageOfBeneficialInterest', (value, context) => {
      const fieldValue = value;
      const { path, createError, parent } = context;
      if (fieldValue === null || (fieldValue === undefined && !parent.isFetchData)) {
        return createError({
          message: `Percentage Of Beneficial Interest is required`,
          path,
        });
      }
      if (fieldValue === 0 && !parent.isFetchData && !checkUBOTypeIsTrust(parent.typeOfUBO)) {
        return createError({
          message: `Percentage Of Beneficial Interest should be greater 0`,
          path,
        });
      }
      if (fieldValue) {
        if (fieldValue < 0 && !parent.isFetchData) {
          return createError({
            message: `Percentage Of Beneficial Interest should be greater than${
              checkUBOTypeIsTrust(parent.typeOfUBO) ? ' or equal to' : ''
            } 0`,
            path,
          });
        }
        if (fieldValue > 100 && !parent.isFetchData) {
          return createError({
            message: `Percentage Of Beneficial Interest must not exceed 100%`,
            path,
          });
        }
      }
      return true;
    }),
  countryOfTaxResidency: yup
    .string()
    .nullable()
    .test('countryOfTaxResidency', (value, context) => {
      return fieldValidation(value, context, 'Country Of Tax Residency');
    }),
  cpUboCode: yup
    .string()
    .nullable()
    .oneOf(Object.keys(CpUboCodesMaster), 'Invalid value for CP/UBO Code')
    .test('cpUboCode', (value, context) => {
      return fieldValidation(value, context, 'Cp/UboCode');
    }),
  placeAndCountryOfBirth: yup
    .string()
    .nullable()
    .when('type', {
      is: (uboType: string) => uboType && isUboTypeNonIndividual(uboType),
      then: yup
        .string()
        .nullable()
        .test('placeAndCountryOfBirth', (value, context) => {
          return fieldValidation(value, context, 'Place of Incorporation');
        }),
      otherwise: yup
        .string()
        .nullable()
        .test('placeAndCountryOfBirth', (value, context) => {
          return fieldValidation(value, context, 'Place and Country Of Birth');
        }),
    }),
  occupation: yup
    .string()
    .nullable()
    .when('type', {
      is: (uboType: string) => isUboTypeIndividual(uboType),
      then: yup
        .string()
        .nullable()
        .test('occupation', (value, context) => {
          return fieldValidation(value, context, 'Occupation');
        }),
    })
    .oneOf(occupationDetailsMasters, 'Invalid value for Occupation'),
  gender: yup
    .string()
    .nullable()
    .when('type', {
      is: (uboType: string) => isUboTypeIndividual(uboType),
      then: yup
        .string()
        .nullable()
        .test('gender', (value, context) => {
          return fieldValidation(value, context, 'Gender');
        }),
    }),
  nationality: yup
    .string()
    .nullable()
    .when('type', {
      is: (uboType: string) => isUboTypeIndividual(uboType),
      then: yup
        .string()
        .nullable()
        .test('nationality', (value, context) => {
          return fieldValidation(value, context, 'Nationality');
        }),
    }),
  // .oneOf(nationalitiesMasters, 'Invalid value for Nationality')
  fatherName: yup
    .string()
    .nullable()
    .when('type', {
      is: (uboType: string) => isUboTypeIndividual(uboType),
      then: yup
        .string()
        .nullable()
        .test('fatherName', (value, context) => {
          return fieldValidation(value, context, "Father's Name");
        }),
    }),
  ckycNumber: yup
    .string()
    .nullable()
    // .length(14, 'Invalid CKYC Number')
    .test('ckycNumber', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, options, parent } = context;
      //eslint-disable-next-line
      const { context: optionsContext } = options as InternalOptions<ubo[]>;
      if (!fieldValue && !parent.isFetchData) {
        return true;
        // return createError({
        //   message: 'CKYC Number is required',
        //   path,
        // });
      } else if (!ckycNumberRegex.test(fieldValue as string) && !parent.isFetchData) {
        return createError({
          message: 'Invalid CKYC Number',
          path,
        });
      }
      // const uboCkycNumbers = optionsContext?.map((ubo) => Number(ubo.ckycNumber).toString());
      // if (uboCkycNumbers && uboCkycNumbers.includes(fieldValue as string) && !parent.isFetchData) {
      //   return createError({
      //     message:
      //       'There is already same CKYC Number for an Ultimate Beneficiary Ownership (UBO) associated with this application',
      //     path,
      //   });
      // }
      return true;
    }),
  address2: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
    )
    .test('address2', (value, context) => {
      return fieldValidation(value, context, 'Address Line 1');
    }),
  address3: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
    )
    .test('address3', (value, context) => {
      return fieldValidation(value, context, 'Address Line 2');
    }),
  city: yup
    .string()
    .nullable()
    .test('city', (value, context) => {
      return fieldValidation(value, context, 'City');
    }),
  state: yup
    .string()
    .nullable()
    .test('state', (value, context) => {
      return fieldValidation(value, context, 'State');
    }),
  country: yup
    .string()
    .nullable()
    .test('country', (value, context) => {
      return fieldValidation(value, context, 'Country');
    }),
  pincode: yup
    .string()
    .nullable()
    .test('pincode', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (!fieldValue && !parent.isFetchData) {
        return createError({
          message: 'Pincode is required',
          path,
        });
      } else if (
        parent.country?.toLowerCase() === 'india' &&
        !indianPin.test(fieldValue as string) &&
        !parent.isFetchData
      ) {
        return createError({
          message: 'Pincode length should be 6 digits',
          path,
        });
      } else if (
        parent.country?.toLowerCase() !== 'india' &&
        !pinCodeRegexOtherThanIndia.test(fieldValue as string) &&
        !parent.isFetchData
      ) {
        return createError({
          message: 'Invalid Pincode',
          path,
        });
      }
      return true;
    }),
});

export const nonIndividualCoparceres = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  pan: yup
    .string()
    .nullable()
    .uppercase()
    .length(10, 'PAN must be exactly 10 characters')
    .matches(individualPanRegex, 'Only individual PANs are allowed')
    .test('pan', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<coparcenersType[]>;
      const CoparceresPanNumbers = optionsContext?.map((Coparceres) => Coparceres.pan).flat();
      // if (!value) {
      //   return createError({
      //     message: 'PAN is required',
      //     path,
      //   });
      // }
      if (value && CoparceresPanNumbers && CoparceresPanNumbers.includes(value)) {
        return createError({
          message: 'There is already same pan for an Coparcener associated with this application',
          path,
        });
      }

      return true;
    }),
  mobile: yup
    .string()
    .nullable()
    .test('mobile', (value, context) => {
      const { path, createError, options, parent } = context;
      const { context: optionsContext } = options as InternalOptions<coparcenersType[]>;
      const coparcenersMobileNumbers = optionsContext
        ?.map((Coparceres) => Coparceres.mobile)
        .flat();
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Mobile Number is required',
          path,
        });
      }
      if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (!isValidPhoneNumber(value, codesList as CountryCode)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (coparcenersMobileNumbers && coparcenersMobileNumbers.includes(value)) {
        return createError({
          message:
            'There is already same mobile number for an Coparcener associated with this application',
          path,
        });
      }

      return true;
    }),
  dob: yup
    .string()
    .nullable()
    .test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (!fieldValue) {
        return createError({
          message: 'Date of birth is required',
          path,
        });
      }
      // if (parent.pan && individualPanRegex.test(parent.pan) && isMinor(fieldValue || '')) {
      //   return createError({
      //     message: 'Age should be greater than 18',
      //     path,
      //   });
      // }
      if (parent.pan && individualPanRegex.test(parent.pan) && maxAge(fieldValue || '')) {
        return createError({
          message: 'Age should be less than 125',
          path,
        });
      }
      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid Email ID')
    .test('email', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<coparcenersType[]>;
      const CoparceresEmailID = optionsContext?.map((Coparceres) => Coparceres.email).flat();
      if (!value) {
        return createError({
          message: 'Email ID is required',
          path,
        });
      }
      if (CoparceresEmailID && CoparceresEmailID.includes(value)) {
        return createError({
          message:
            'There is already same Email ID for an Coparcener associated with this application',
          path,
        });
      }

      return true;
    }),

  relation: yup
    .string()
    .nullable()
    .test('relation', (value, context) => {
      const fieldValue = value === null ? '' : value;
      const { options, createError, path } = context;
      const { index } = options as InternalOptions<ContributorValues> & {
        index: number;
      };
      if (index !== 0) {
        if (!fieldValue) {
          return createError({
            message: 'Relationship is required',
            path,
          });
        }
        if (fieldValue && !Relations.includes(fieldValue)) {
          return createError({
            message: 'Invalid value for Relationship',
            path,
          });
        }
      }
      return true;
    }),
  relationShipOthers: yup
    .string()
    .nullable()
    .when('relation', {
      is: (relation: string | null) => relation === 'Others',
      then: yup.string().nullable().required('Please Specify Relationship'),
    }),
  designation: yup.string().nullable().required('Designation is required'),
});

export const nonIndividualControllingPersons = yup.object().shape({
  name: yup.string().nullable().required('Name of controlling person is required'),
  correspondenceAddress: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "Invalid address format [special characters are not allowed except -/',&()#:.]"
    )
    .required('Correspondence address is required'),
  countryOfResidense: yup
    .string()
    .nullable()
    .required('Country of residence for tax purposes is required'),
  issuingCountry: yup.string().nullable().required('Issuing country is required'),
  controllingPersonType: yup.string().nullable().required('Controlling Person Type is required'),
  indentificationType: yup.string().nullable().required('Indentification Type is required'),
  indentificationNumber: yup
    .string()
    .nullable()
    .test('indentificationNumber', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<ControllingPersons[]>;
      const indentificationNumberArr = optionsContext?.map(
        (person) => person.indentificationNumber
      );
      if (!value) {
        return createError({
          message: 'Indentification Number is required',
          path,
        });
      }
      if (value && !alphaNumeric.test(value)) {
        return createError({
          message: 'Special Characters are Not allowed',
          path,
        });
      }
      if (indentificationNumberArr && indentificationNumberArr.includes(value)) {
        return createError({
          message:
            'There is already same Indentification Number for a Controlling Persons associated with this application',
          path,
        });
      }

      return true;
    }),
  occupationType: yup.string().nullable().required('Occupation Type is required'),
  occupation: yup
    .string()
    .nullable()
    .oneOf(occupationDetailsMasters, 'Invalid value for Occupation')
    .required('Occupation is required'),
  dateOfBirth: yup
    .string()
    .nullable()
    .test('dateOfBirth', (value, context) => {
      const { path, createError } = context;
      if (!value) {
        return createError({
          message: 'Date of Birth is required',
          path,
        });
      }
      if (isMinor(value)) {
        return createError({
          message: 'Age should be greater than 18',
          path,
        });
      }
      if (maxAge(value)) {
        return createError({
          message: 'Age should be less than 125',
          path,
        });
      }
      return true;
    }),
  countryOfBirth: yup.string().nullable().required('Country Of Birth is required'),
  nationality: yup.string().nullable().required('Nationality is required'),
  tin: yup
    .string()
    .nullable()
    .test('tin', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<ControllingPersons[]>;
      const controllingPersons = optionsContext?.map((person) => person.tin);
      if (!value) {
        return createError({
          message: 'TIN is required',
          path,
        });
      }
      if (value && !alphaNumeric.test(value)) {
        return createError({
          message: 'Special Characters are Not allowed',
          path,
        });
      }
      if (controllingPersons && controllingPersons.includes(value)) {
        return createError({
          message:
            'There is already same Tin for a Controlling Persons associated with this application',
          path,
        });
      }

      return true;
    }),
});

type errorObj = { fieldPath: string; fieldName: string };

const subQuestionsValidation = (
  fatca: nonIndividualQuestionsFatca,
  path: string
): errorObj | errorObj[] | undefined => {
  if (
    !fatca.answer &&
    fatca.isVisible &&
    fatca.backend_key &&
    fatca.isMandatory === 'true' &&
    fatca.question_type !== 'Controlling_person_details'
  ) {
    const fieldPath =
      path + '.' + getSubQuestionsIndex(fatca.id.split('Q')[1].split('.'), '', true);
    return {
      fieldPath: fieldPath,
      fieldName:
        fatca.question_type === 'single_choice_radio'
          ? 'Field is required'
          : fatca.question_text
          ? fatca.question_text + ' is required'
          : (fatca.placeholder || 'Field') + ' is required',
    };
  }
  if (
    fatca.answer &&
    fatca.isVisible &&
    fatca.backend_key &&
    fatca.validation === 'alphaNumeric' &&
    !alphaNumeric.test(fatca.answer)
  ) {
    const fieldPath =
      path + '.' + getSubQuestionsIndex(fatca.id.split('Q')[1].split('.'), '', true);
    return {
      fieldPath: fieldPath,
      fieldName: 'Special Characters are Not allowed',
    };
  }
  if (fatca.question_type === 'group' && fatca.isVisible && fatca.sub_questions?.length) {
    return fatca.sub_questions
      ?.map((qun) => subQuestionsValidation(qun, path) as errorObj)
      .filter((ele: errorObj) => ele)
      .flat();
  }
};

export const nonIndividualFatcaSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      fatcadetail: yup
        .array()
        .nullable()
        .of(
          yup.object().shape({
            answer: yup
              .string()
              .nullable()
              .when('wishToUploadFatcaDocument', {
                is: (wishToUploadFatcaDocument: boolean | null) => !wishToUploadFatcaDocument,
                then: yup
                  .string()
                  .nullable()
                  .test('answer', (value, context) => {
                    const { path, createError, parent } = context;
                    if (
                      !value &&
                      parent.isVisible &&
                      parent.isMandatory === 'true' &&
                      parent.backend_key &&
                      parent.question_type !== 'single_choice_radio'
                    ) {
                      return createError({
                        message:
                          parent.question_type === 'open_text_field'
                            ? (parent.placeholder || 'Field') + ' is required'
                            : parent.question_text
                            ? parent.question_text + ' is required'
                            : (parent.placeholder || 'Field') + ' is required',
                        path,
                      });
                    }
                    if (
                      value &&
                      parent.isVisible &&
                      parent.backend_key &&
                      parent.validation === 'alphaNumeric' &&
                      !alphaNumeric.test(value)
                    ) {
                      return createError({
                        message: 'Special Characters are Not allowed',
                        path,
                      });
                    }
                    if (
                      parent.question_type === 'group' &&
                      parent.isVisible &&
                      parent.sub_questions
                    ) {
                      //subQuestionsValidation(value, context)
                      const res: errorObj[] = [];
                      const val = parent.sub_questions
                        ?.map((qun: nonIndividualQuestionsFatca) => {
                          const r = subQuestionsValidation(qun, path?.split('.')[0]) as errorObj;
                          return r;
                          // return (r as errorObj)
                          //   ? new yup.ValidationError(r.fieldName, '', `${r.fieldPath}.answer`)
                          //   : (r as unknown as errorObj[])?.map(
                          //       (ele: errorObj) =>
                          //         new yup.ValidationError(ele.fieldName, '', `${ele.fieldPath}.answer`)
                          //     );
                        })
                        .filter((ele: errorObj) => ele)
                        .flat();
                      // .toString();
                      if (val.length) {
                        const error = val.map((ele: errorObj) => {
                          return new yup.ValidationError(
                            ele.fieldName,
                            '',
                            `${ele.fieldPath}.answer`
                          );
                        });
                        if (error.length) {
                          return new yup.ValidationError(error);
                        }

                        // return createError({
                        //   message: 'Field is Required1',
                        //   path: `${val}.answer`,
                        // });
                      }
                      return true;
                    }
                    return true;
                  }),
              }),
          })
        ),
      fatcaGrossAnnualIncome: yup.string().nullable().required('Gross Annual Income is required'),
    })
  ),
});

export const addPlanValidation = yup.object().shape({
  planCode: yup.string().nullable().required('Plan Code is required'),
  planDescription: yup.string().nullable().required('Plan Description is required'),
  schemeNature: yup.string().nullable().required('Scheme Nature is required'),
  // registrationNumber: yup.string().nullable().required('Registration Number is required'),
  fundManagerId: yup.string().nullable().required('Investment Manager Name is required'),
  trusteeId: yup.string().nullable().required('Trustee Name is required'),
  planClass: yup.string().nullable().required('Fee Structure is required'),
  schemeCategory: yup.string().nullable().required('Scheme Category is required'),
  minCommitmentAmount: yup
    .number()
    .nullable()
    .moreThan(0, `Minimum Commitment Amount should be greater than 0`)
    .required('Minimum Commitment Amount is required'),
  maxCommitmentAmount: yup
    .number()
    .nullable()
    .min(
      yup.ref('minCommitmentAmount'),
      'Maximum Commitment Amount should be greater than or equal to Minimum Commitment Amount'
    )
    .required('Maximum Commitment Amount is required'),
  classOfUnits: yup
    .string()
    .nullable()
    .required('Class of units is required')
    .matches(alphaNumeric, 'Invalid value for class of units'),
  hurdleRateApplicable: yup
    .string()
    .nullable()
    .required('Hurdle Rate Applicable is required')
    .oneOf(Object.keys(YES_NO_MASTER), 'Invalid value of Hurdle Rate Applicable'),
  hurdleRateType: yup
    .string()
    .nullable()
    .when('hurdleRateApplicable', {
      is: (hurdleRateApplicable: string) => isFieldApplicable(hurdleRateApplicable),
      then: yup
        .string()
        .nullable()
        .required('Hurdle Rate Type is required')
        .oneOf(Object.keys(FEE_TYPE_MASTER), 'Invalid value of Hurdle Rate Type'),
    }),
  defaultHurdleRate: yup
    .number()
    .nullable()
    .test('defaultHurdleRate', (value, context) => {
      const { path, createError, parent } = context;
      if (!value && value !== 0 && isFieldApplicable(parent?.hurdleRateApplicable)) {
        return createError({
          message: 'Hurdle Rate is required',
          path,
        });
      }
      if (
        (value || value === 0) &&
        isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable) &&
        (value < Number(parent?.minHurdleRate || 0) || value > Number(parent?.maxHurdleRate || 100))
      ) {
        return createError({
          message: `Hurdle Rate should be in between or equal to ${
            parent?.minHurdleRate || 0
          } and ${parent?.maxHurdleRate || 100}`,
          path,
        });
      }

      if (
        value &&
        !isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable) &&
        (value < 0 || value > 100)
      ) {
        return createError({
          message: 'Hurdle Rate should be in between or equal to 0 and 100',
          path,
        });
      }
      return true;
    }),
  minHurdleRate: yup
    .number()
    .nullable()
    .test('minHurdleRate', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Minimum Hurdle Rate is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Minimum Hurdle Rate should be greater than 0',
            path,
          });
        }
        if (
          value >
          (parent?.maxHurdleRate || parent?.maxHurdleRate === 0
            ? Number(parent?.maxHurdleRate)
            : 100)
        ) {
          return createError({
            message: 'Minimum Hurdle Rate should be less than or equal to Maximum Hurdle Rate',
            path,
          });
        }
      }
      return true;
    }),
  maxHurdleRate: yup
    .number()
    .nullable()
    .test('maxHurdleRate', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Maximum Hurdle Rate is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Maximum Hurdle Rate should be greater than 0',
            path,
          });
        }
        if (
          value <
          (parent?.minHurdleRate || parent?.minHurdleRate === 0 ? Number(parent?.minHurdleRate) : 0)
        ) {
          return createError({
            message: 'Maximum Hurdle Rate should be greater than or equal to Minimum Hurdle Rate',
            path,
          });
        }
      }
      return true;
    }),
  performanceFeeApplicable: yup
    .string()
    .nullable()
    .required('Performance Fee Applicable is required')
    .oneOf(Object.keys(YES_NO_MASTER), 'Invalid value of Performance Fee Applicable'),
  performanceFeeType: yup
    .string()
    .nullable()
    .when('performanceFeeApplicable', {
      is: (performanceFeeApplicable: string) => isFieldApplicable(performanceFeeApplicable),
      then: yup
        .string()
        .nullable()
        .required('Performance Fee Type is required')
        .oneOf(Object.keys(FEE_TYPE_MASTER), 'Invalid value of Performance Fee Type'),
    }),
  defaultPerformanceFee: yup
    .number()
    .nullable()
    .test('defaultPerformanceFee', (value, context) => {
      const { path, createError, parent } = context;
      if (!value && value !== 0 && isFieldApplicable(parent?.performanceFeeApplicable)) {
        return createError({
          message: 'Performance Fee is required',
          path,
        });
      }
      if (
        (value || value === 0) &&
        isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable) &&
        (value < Number(parent?.minPerformanceFee || 0) ||
          value > Number(parent?.maxPerformanceFee || 100))
      ) {
        return createError({
          message: `Performance Fee should be in between or equal to ${
            parent?.minPerformanceFee || 0
          } and ${parent?.maxPerformanceFee || 100}`,
          path,
        });
      }

      if (
        value &&
        !isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable) &&
        (value < 0 || value > 100)
      ) {
        return createError({
          message: 'Performance Fee should be in between or equal to 0 and 100',
          path,
        });
      }
      return true;
    }),
  minPerformanceFee: yup
    .number()
    .nullable()
    .test('minPerformanceFee', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Minimum Performance Fee is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Minimum Performance Fee should be greater than 0',
            path,
          });
        }
        if (
          value >
          (parent?.maxPerformanceFee || parent?.maxPerformanceFee === 0
            ? Number(parent?.maxPerformanceFee)
            : 100)
        ) {
          return createError({
            message:
              'Minimum Performance Fee should be less than or equal to Maximum Performance Fee',
            path,
          });
        }
      }
      return true;
    }),
  maxPerformanceFee: yup
    .number()
    .nullable()
    .test('maxPerformanceFee', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Maximum Performance Fee is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Maximum Performance Fee should be greater than 0',
            path,
          });
        }
        if (
          value <
          (parent?.minPerformanceFee || parent?.minPerformanceFee === 0
            ? Number(parent?.minPerformanceFee)
            : 0)
        ) {
          return createError({
            message:
              'Maximum Performance Fee should be greater than or equal to Minimum Performance Fee',
            path,
          });
        }
      }
      return true;
    }),
});
const invesmentMethodsSchema = yup.object().shape({
  modeOfInvestment: yup
    .array()
    .nullable()
    .min(1, 'Investment Methods is required')
    .required('Investment Methods is required'),
  drawdownDetails: yup.object().shape({
    percentage: yup
      .string()
      .nullable()
      .test('percentage', (value, context) => {
        const {
          options: { context: optionsContext },
          createError,
          path,
        } = context;
        const { modeOfInvestment } = optionsContext || {};
        const fieldValue = value === undefined ? '' : value;
        if (checkDrawdown(modeOfInvestment)) {
          if (!fieldValue) {
            return createError({
              message: 'Percentage is required',
              path,
            });
          }
          if (fieldValue && !percentageCommaSparatedRegex.test(fieldValue)) {
            return createError({
              message: 'Invalid value',
              path,
            });
          }
          if (fieldValue && Number(value) > 100) {
            return createError({
              message: 'Percentage should be less then 100%',
              path,
            });
          }
        }
        return true;
      }),
  }),
  sipDetails: yup.array().of(
    yup.object().shape({
      percentage: yup
        .string()
        .nullable()
        .test('percentage', (value, context) => {
          const {
            options: { context: optionsContext },
            createError,
            path,
            parent,
          } = context;
          const { modeOfInvestment, sipDetails } = optionsContext || {};
          const fieldValue = value === undefined ? '' : value;
          if (checkSip(modeOfInvestment)) {
            if (!fieldValue) {
              return createError({
                message: 'Percentage is required',
                path,
              });
            }
            if (fieldValue && !percentageRegex.test(fieldValue)) {
              return createError({
                message: 'Invalid value',
                path,
              });
            }
            if (
              fieldValue &&
              sipDetails?.some(
                (item: SipInvestmentModeProp) =>
                  item?.sno !== parent?.sno && item?.percentage === fieldValue
              )
            ) {
              return createError({
                message: 'Duplicate percentage',
                path,
              });
            }

            if (fieldValue && Number(value) > 100) {
              return createError({
                message: 'Percentage should be less then 100%',
                path,
              });
            }
          }
          return true;
        }),
      months: yup
        .string()
        .nullable()
        .test('months', (value, context) => {
          const {
            options: { context: optionsContext },
            createError,
            path,
          } = context;
          const { modeOfInvestment } = optionsContext || {};
          const fieldValue = value === undefined ? '' : value;
          if (checkSip(modeOfInvestment)) {
            if (!fieldValue) {
              return createError({
                message: 'Months is required',
                path,
              });
            }
            if (fieldValue && !percentageMonthsRegex.test(fieldValue)) {
              return createError({
                message: 'Invalid value',
                path,
              });
            }
          }
          return true;
        }),
    })
  ),
  lumpsumDetails: yup.object().shape({
    percentage: yup
      .string()
      .nullable()
      .test('percentage', (value, context) => {
        const {
          options: { context: optionsContext },
          createError,
          path,
        } = context;
        const { modeOfInvestment } = optionsContext || {};
        const fieldValue = value === undefined ? '' : value;
        if (checkLumpsum(modeOfInvestment)) {
          if (!fieldValue) {
            return createError({
              message: 'Percentage is required',
              path,
            });
          }
          if (fieldValue && !percentageCommaSparatedRegex.test(fieldValue)) {
            return createError({
              message: 'Invalid value',
              path,
            });
          }
          if (fieldValue && Number(value) > 100) {
            return createError({
              message: 'Percentage should be less then 100%',
              path,
            });
          }
        }
        return true;
      }),
  }),
});
export const addFundValidation = invesmentMethodsSchema.shape({
  schemeCode: yup.string().nullable().required('Scheme Code is required'),
  schemeName: yup.string().nullable().required('Scheme Name is required'),
  planCode: yup.string().nullable().required('Plan Code is required'),
  planDescription: yup.string().nullable().required('Plan Description is required'),
  schemeNature: yup.string().nullable().required('Scheme Nature is required'),
  // registrationNumber: yup.string().nullable().required('Registration Number is required'),
  fundManagerId: yup.string().nullable().required('Investment Manager Name is required'),
  trusteeId: yup.string().nullable().required('Trustee Name is required'),
  planClass: yup.string().nullable().required('Fee Structure is required'),
  schemeCategory: yup.string().nullable().required('Scheme Category is required'),
  minCommitmentAmount: yup
    .number()
    .nullable()
    .moreThan(0, `Minimum Commitment Amount should be greater than 0`)
    .required('Minimum Commitment Amount is required'),
  maxCommitmentAmount: yup
    .number()
    .nullable()
    .min(
      yup.ref('minCommitmentAmount'),
      'Maximum Commitment Amount should be greater than or equal to Minimum Commitment Amount'
    )
    .required('Maximum Commitment Amount is required'),

  LEEGALITY_STAMP_SERIES: yup
    .string()
    .nullable()
    .required('Stamp Paper Series is required')
    .matches(alphaNumeric, 'Special characters are not allowed'),
  LEEGALITY_STAMP_SERIES_GROUP: yup
    .string()
    .nullable()
    .required('Stamp Paper Group is required')
    .matches(alphaNumeric, 'Special characters are not allowed'),
  LEEGALITY_STAMP_VALUE: yup.number().nullable().required('Stamp Paper Value is required'),
  // LEEGALITY_USE_STAMP_SERIES: yup
  //   .boolean()
  //   .nullable()
  //   .required('Select one to choose series or group type Stamp Paper'),
  classOfUnits: yup
    .string()
    .nullable()
    .required('Class of units is required')
    .matches(alphaNumeric, 'Invalid value for class of units'),
  hurdleRateApplicable: yup
    .string()
    .nullable()
    .required('Hurdle Rate Applicable is required')
    .oneOf(Object.keys(YES_NO_MASTER), 'Invalid value of Hurdle Rate Applicable'),
  hurdleRateType: yup
    .string()
    .nullable()
    .when('hurdleRateApplicable', {
      is: (hurdleRateApplicable: string) => isFieldApplicable(hurdleRateApplicable),
      then: yup
        .string()
        .nullable()
        .required('Hurdle Rate Type is required')
        .oneOf(Object.keys(FEE_TYPE_MASTER), 'Invalid value of Hurdle Rate Type'),
    }),
  defaultHurdleRate: yup
    .number()
    .nullable()
    .test('defaultHurdleRate', (value, context) => {
      const { path, createError, parent } = context;
      if (!value && value !== 0 && isFieldApplicable(parent?.hurdleRateApplicable)) {
        return createError({
          message: 'Hurdle Rate is required',
          path,
        });
      }
      if (
        (value || value === 0) &&
        isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable) &&
        (value < Number(parent?.minHurdleRate || 0) || value > Number(parent?.maxHurdleRate || 100))
      ) {
        return createError({
          message: `Hurdle Rate should be in between or equal to ${
            parent?.minHurdleRate || 0
          } and ${parent?.maxHurdleRate || 100}`,
          path,
        });
      }

      if (
        value &&
        !isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable) &&
        (value < 0 || value > 100)
      ) {
        return createError({
          message: 'Hurdle Rate should be in between or equal to 0 and 100',
          path,
        });
      }
      return true;
    }),
  minHurdleRate: yup
    .number()
    .nullable()
    .test('minHurdleRate', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Minimum Hurdle Rate is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Minimum Hurdle Rate should be greater than 0',
            path,
          });
        }
        if (
          value >
          (parent?.maxHurdleRate || parent?.maxHurdleRate === 0
            ? Number(parent?.maxHurdleRate)
            : 100)
        ) {
          return createError({
            message: 'Minimum Hurdle Rate should be less than or equal to Maximum Hurdle Rate',
            path,
          });
        }
      }
      return true;
    }),
  maxHurdleRate: yup
    .number()
    .nullable()
    .test('maxHurdleRate', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.hurdleRateType, parent.hurdleRateApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Maximum Hurdle Rate is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Maximum Hurdle Rate should be greater than 0',
            path,
          });
        }
        if (
          value <
          (parent?.minHurdleRate || parent?.minHurdleRate === 0 ? Number(parent?.minHurdleRate) : 0)
        ) {
          return createError({
            message: 'Maximum Hurdle Rate should be greater than or equal to Minimum Hurdle Rate',
            path,
          });
        }
      }
      return true;
    }),
  performanceFeeApplicable: yup
    .string()
    .nullable()
    .required('Performance Fee Applicable is required')
    .oneOf(Object.keys(YES_NO_MASTER), 'Invalid value of Performance Fee Applicable'),
  performanceFeeType: yup
    .string()
    .nullable()
    .when('performanceFeeApplicable', {
      is: (performanceFeeApplicable: string) => isFieldApplicable(performanceFeeApplicable),
      then: yup
        .string()
        .nullable()
        .required('Performance Fee Type is required')
        .oneOf(Object.keys(FEE_TYPE_MASTER), 'Invalid value of Performance Fee Type'),
    }),
  defaultPerformanceFee: yup
    .number()
    .nullable()
    .test('defaultPerformanceFee', (value, context) => {
      const { path, createError, parent } = context;
      if (!value && value !== 0 && isFieldApplicable(parent?.performanceFeeApplicable)) {
        return createError({
          message: 'Performance Fee is required',
          path,
        });
      }
      if (
        (value || value === 0) &&
        isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable) &&
        (value < Number(parent?.minPerformanceFee || 0) ||
          value > Number(parent?.maxPerformanceFee || 100))
      ) {
        return createError({
          message: `Performance Fee should be in between or equal to ${
            parent?.minPerformanceFee || 0
          } and ${parent?.maxPerformanceFee || 100}`,
          path,
        });
      }

      if (
        value &&
        !isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable) &&
        (value < 0 || value > 100)
      ) {
        return createError({
          message: 'Performance Fee should be in between or equal to 0 and 100',
          path,
        });
      }
      return true;
    }),
  minPerformanceFee: yup
    .number()
    .nullable()
    .test('minPerformanceFee', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Minimum Performance Fee is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Minimum Performance Fee should be greater than 0',
            path,
          });
        }
        if (
          value >
          (parent?.maxPerformanceFee || parent?.maxPerformanceFee === 0
            ? Number(parent?.maxPerformanceFee)
            : 100)
        ) {
          return createError({
            message:
              'Minimum Performance Fee should be less than or equal to Maximum Performance Fee',
            path,
          });
        }
      }
      return true;
    }),
  maxPerformanceFee: yup
    .number()
    .nullable()
    .test('maxPerformanceFee', (value, context) => {
      const { path, createError, parent } = context;
      if (isFieldVariable(parent?.performanceFeeType, parent.performanceFeeApplicable)) {
        if (!value && value !== 0) {
          return createError({
            message: 'Maximum Performance Fee is required',
            path,
          });
        }
        if (value < 0) {
          return createError({
            message: 'Maximum Performance Fee should be greater than 0',
            path,
          });
        }
        if (
          value <
          (parent?.minPerformanceFee || parent?.minPerformanceFee === 0
            ? Number(parent?.minPerformanceFee)
            : 0)
        ) {
          return createError({
            message:
              'Maximum Performance Fee should be greater than or equal to Minimum Performance Fee',
            path,
          });
        }
      }
      return true;
    }),
});

export const editFundValidation = invesmentMethodsSchema.shape({
  schemeCode: yup.string().nullable().required('Scheme Code is required'),
  schemeName: yup.string().nullable().required('Scheme Name is required'),
  LEEGALITY_STAMP_SERIES: yup
    .string()
    .nullable()
    .required('Stamp Paper Series is required')
    .matches(alphaNumeric, 'Special characters are not allowed'),
  LEEGALITY_STAMP_SERIES_GROUP: yup
    .string()
    .nullable()
    .required('Stamp Paper Group is required')
    .matches(alphaNumeric, 'Special characters are not allowed'),
  LEEGALITY_STAMP_VALUE: yup.number().nullable().required('Stamp Paper Value is required'),
  // LEEGALITY_USE_STAMP_SERIES: yup.boolean().nullable().required('Field is required'),
});
